// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:35:32.411Z
// Property: Eleven Oaks (ID: 6767906449167576)
// Collections: 10 amenities, 6 floorplans (live), 34 photos, 41 POIs, 6 virtual tours, 6 office hours, 1 special offers (live), 20 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167576",
  "property_external_id": "1661779",
  "property_zillow_url": "https://www.zillow.com/apartments/eustis-fl/eleven-oaks/CjcwmD/",
  "property_apartments_url": "https://www.apartments.com/eleven-oaks-eustis-fl/0z43qt1/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": "57142105398",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "eleven-oaks",
  "property_name": "Eleven Oaks",
  "property_website_url": "https://www.elevenoakshomes.com",
  "property_domain": "https://www.elevenoakshomes.com",
  "property_address": "175 Eleven Oaks Circle",
  "property_full_address": "175 Eleven Oaks Cir, Eustis, FL 32726",
  "property_address_1": "175 Eleven Oaks Circle",
  "property_address_2": null,
  "property_address_city": "Eustis",
  "property_address_state": "FL",
  "property_address_zip_full": "32726",
  "property_address_zip": "32726",
  "property_address_country": "US",
  "property_address_county": "Lake County",
  "property_neighborhood_address": "Lake County",
  "property_address_latitude": "28.852062",
  "property_address_longitude": "-81.65222",
  "property_email": "quinley@quinnresidences-leasing.com",
  "property_phone": "(866) 606-4559",
  "property_call_tracking_phone": "855-526-6018",
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Single-family homes",
  "property_short_description": "<p><strong>Newly built rental-home living with room to settle in.</strong> Eleven Oaks pairs two- and three-bedroom townhome-style and single-family layouts with polished finishes, smart-home features, green space, and lawn maintenance—explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_long_description": "<p><strong>Newly built rental-home living meets the lake-country ease of Eustis.</strong> At Eleven Oaks, you get the space and privacy of two- and three-bedroom townhome-style and single-family layouts, paired with polished everyday finishes like stainless steel appliances, granite countertops, luxury flooring, smart-home technology, spacious closets, and in-unit laundry. Step outside to landscaped green space, a private park, playground, dog park, fire pit area, BBQ grills, and the added simplicity of lawn maintenance.</p><p>Set in Central Florida’s Golden Triangle, Eleven Oaks puts you close to Historic Downtown Eustis, Lake Eustis, and Ferran Park’s waterfront promenade, bandshell, and scenic lakefront setting. Local dining, shops, and entertainment are nearby, with Mount Dora and Tavares just a short drive away for more lakeside restaurants, events, and small-town character. Explore <a href=\"/floor-plans\">available floor plans</a>, browse the <a href=\"/amenities\">community amenities</a>, or see more of the area on the <a href=\"/neighborhood\">neighborhood page</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-d94c-7631-b6cb-b05be4161fc4.webp",
  "property_featured_image_media": {
    "alt_text": "A single-family home with a beige exterior, attached two-car garage, and green lawn.",
    "public_id": "019fbdae-d94c-7631-b6cb-b05be4161fc4",
    "storage_key": "property/6767906449167576/019fbdae-d94c-7631-b6cb-b05be4161fc4.webp",
    "width": 1024,
    "height": 768
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167576/01a0c014-6fc9-75eb-aca2-b42acb8e234e.mp4",
  "property_featured_video_media": {
    "public_id": "01a0c014-6fc9-75eb-aca2-b42acb8e234e",
    "storage_key": "property/6767906449167576/01a0c014-6fc9-75eb-aca2-b42acb8e234e.mp4",
    "thumbnail_key": "property/6767906449167576/01a0c014-6fc9-75eb-aca2-b42acb8e234e_thumb.webp",
    "size_bytes": 29126555,
    "classification": "Community",
    "title": "Discover Our Beautiful Community: Aerial Tour",
    "description": "Explore our vibrant community from a bird's-eye view. See the well-maintained exteriors, green spaces, and the overall charm of our neighborhood."
  },
  "property_total_units": "69",
  "property_year_built": "2022",
  "property_year_renovated": null,
  "property_walk_score": "23",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "88.40579710144928",
  "property_admin_fee": "350",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit varies with application screening; a security deposit alternative is available. Required monthly charges: utility billing $11.99, concierge package $10.95, landscaping $70 (single-family home) or $45 (townhome), smart home package $35, solar fee $50; renters insurance required. Application fee $100 per adult applicant; administrative fee $350 (one-time). See the Easy Fee Guide for the full schedule.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet; no more than two pets without written approval from Quinn Property Management.",
  "property_pet_policy_description": "Pet Screening: Mandatory for all applicants before move‑in. Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained. Non‑refundable pet fee: $300 for one pet; $500 for up to two pets. Monthly pet rent: $35 per pet. Dangerous or poisonous animals and exotic pets are not permitted. Fish tanks limited to 20 gallons; no pet fee or pet rent required for fish.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://elevenoakshomes.securecafe.com/onlineleasing/eleven-oaks/floorplans.aspx",
  "property_resident_portal_url": "https://elevenoakshomes.securecafenet.com/residentservices/eleven-oaks/userlogin",
  "property_apply_now_url": "https://elevenoakshomes.securecafe.com/onlineleasing/eleven-oaks/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": null,
  "property_primary_logo_media": null,
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/01a0f8d1-31da-70b9-8597-2cc41b0719e1.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a0f8d1-31da-70b9-8597-2cc41b0719e1",
    "storage_key": "property/6767906449167576/01a0f8d1-31da-70b9-8597-2cc41b0719e1.webp",
    "width": 83,
    "height": 64
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/01a0f8d1-2331-73af-a94c-1fe26ba04bac.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0f8d1-2331-73af-a94c-1fe26ba04bac",
    "storage_key": "property/6767906449167576/01a0f8d1-2331-73af-a94c-1fe26ba04bac.webp",
    "width": 83,
    "height": 64
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#563820",
  "property_secondary_color": "#3e5b1b",
  "property_font_color": "#606161",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2 - 3",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "3",
  "property_sqft_range": "1335 - 1650",
  "property_sqft_min": "1335",
  "property_sqft_max": "1650",
  "property_price_range": "1899 - 2587",
  "property_price_min": "1899",
  "property_price_max": "2623",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/Eleven-Oaks-100440059226617/",
  "property_instagram_url": "https://www.instagram.com/elevenoakshomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJGeywD4mj54gRMFeMF2coFDI",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Eleven Oaks",
  "property_home_romance_title": "Embrace Life in Your Dream Home Community",
  "property_home_amenities_blurb": "<p><strong>Green space, polished finishes, and everyday ease.</strong> Eleven Oaks pairs low-maintenance living with room to unwind, including a private park, dog park, fire pit, and BBQ area. Inside, stainless steel appliances, granite countertops, spacious closets, smart-home technology, luxury flooring, and in-unit laundry bring a refined feel to each layout—so comfort comes built in, from the front door to the open air.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit at Eleven Oaks.</strong> Explore two- and three-bedroom rental homes in Eustis, including townhome-style and single-family layouts with open living areas, smart-home features, in-unit laundry, spacious closets, and polished finishes like granite countertops, stainless steel appliances, and luxury flooring. Select homes add a lanai patio or garage for even more everyday ease.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Eleven Oaks.</strong> Preview newly built rental homes with bright island kitchens, stone countertops, stainless steel appliances, modern flooring, roomy closets, and outdoor patios or lawns. Then explore landscaped courtyards, walking paths, pet-friendly green space, a playground, and relaxed gathering areas that bring the Eustis setting into focus.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Lake-country calm, Golden Triangle character.</strong> From Eleven Oaks, everyday plans can stretch from the Lake Eustis waterfront at Ferran Park to downtown Eustis near Bay Street, with Mount Dora’s brick-street shops, galleries, and dining just an easy outing away. Tavares adds more waterfront energy with Wooton Park, seaplane views, and restaurants by the water. Explore the map to see what’s close.</p>",
  "property_home_reviews_blurb": "<p><strong>See what stands out at Eleven Oaks.</strong> Resident feedback offers a closer look at everyday life in this Eustis rental-home community, from home features and shared spaces to the overall experience. Explore highlighted ratings here, then read more reviews to help shape your next step—or connect with the leasing team when you’re ready to visit.</p>",
  "property_neighborhood_blurb": "<p><strong>Start with lake-country days, then widen the map.</strong> From Eleven Oaks, Eustis puts you close to the calm of Lake County and the character of Central Florida’s Golden Triangle. Spend time along the Lake Eustis waterfront at Ferran Park, browse downtown Eustis near Bay Street, or make an easy outing to Mount Dora for brick-street shopping, galleries, and destination dining. Tavares adds its own waterfront energy, with Wooton Park, seaplane views, and restaurants by the water.</p><p>Back at home, you can trade the day’s plans for your own yard, patio, and <a href=\"/amenities\">everyday conveniences</a> designed to keep life simple. Use the map below to explore nearby parks, cafés, errands, and local highlights—then see how naturally Eleven Oaks connects you to them.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make daily living feel lighter.</strong> At Eleven Oaks, your home extends into open green space designed for easy time outdoors, from a private park and dog park to a fire pit and BBQ area made for unwinding close to home. Lawn maintenance is handled for you, so your weekends can feel a little more your own.</p><p>Inside, polished finishes bring the same low-effort comfort to your routine. Cook with stainless steel appliances and granite countertops, keep things organized with spacious closets, and enjoy smart-home technology, luxury flooring, and in-unit laundry in every layout. Browse the <a href=\"/gallery\">photo gallery</a>, review <a href=\"/pet-policy\">pet-friendly details</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the amenities come together in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready for newly built rental-home living?</strong> Start your application online for Eleven Oaks and enjoy townhome-style or single-family space with polished finishes like stainless steel appliances, granite countertops, smart-home technology, spacious closets, and in-unit laundry—all with the ease of lawn maintenance and inviting outdoor community spaces.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> The leasing team at Eleven Oaks is here to help you explore newly built rental-home living in Eustis, from two- and three-bedroom layouts to polished finishes, green space, and everyday convenience. Reach out today—we’ll point you in the right direction.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Eleven Oaks?</strong> Start here for quick answers about rental-home living, leasing, community features, and everyday details at Eleven Oaks. If you need anything more specific, the leasing team is happy to help you find the information you need.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that matches your rhythm.</strong> Eleven Oaks offers two- and three-bedroom rental homes in Eustis, with a mix of townhome-style and single-family designs that give you room to cook, recharge, work, store, and settle in comfortably. Compare open living areas, bedroom placement, bath count, and attached-home conveniences as you browse current pricing and availability.</p><p>Inside, thoughtful finishes make each floor plan feel polished from the start, with details like granite countertops, stainless steel appliances, luxury flooring, smart-home features, spacious closets, and in-unit laundry. Select homes may also include extras such as a lanai patio or garage. Explore the cards below, view photos in the <a href=\"/gallery\">gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the finish, flow, and outdoor space.</strong> Browse the Eleven Oaks photo gallery for a closer look at newly built rental homes in Eustis, from bright island kitchens with stone countertops and stainless steel appliances to open living areas finished with clean, modern flooring. See bedrooms with generous closet space, laundry conveniences tucked into the plan, and patios or lawns that add a little fresh-air room just outside your door.</p><p>Community photos bring the setting into view, too: landscaped courtyards, walking paths, a playground, pet-friendly green space, and gathering spots designed for easy time outdoors. As you scroll, compare the look and feel of different <a href=\"/floor-plans\">two- and three-bedroom layouts</a>, then continue with <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Eleven Oaks in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Eleven Oaks on the map.</strong><br>See available two- and three-bedroom rental homes, then zoom out to discover Eustis lake-country conveniences, nearby dining, shopping, entertainment, and the Golden Triangle destinations just a short drive away.</p>",
  "property_pets_blurb": "<p><strong>Bring the leash—and a little room to roam.</strong> Eleven Oaks makes pet-friendly rental-home living feel easy in Eustis, with landscaped green space, a dedicated dog park, and outdoor areas that give daily walks more variety close to home. Inside, roomy two- and three-bedroom layouts offer practical space for crates, beds, litter boxes, and the everyday gear that comes with caring for a companion.</p><p>After pet screening, approved pets can settle into a home designed for simple routines, from in-home laundry to easy-care finishes and lawn maintenance that keeps outdoor areas looking fresh. Explore the <a href=\"/amenities\">pet-friendly amenities</a>, compare <a href=\"/floor-plans\">available layouts</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Eleven Oaks supports life with your pet.</p>",
  "property_referafriend_blurb": "<p><strong>Share the lake-country ease of Eleven Oaks.</strong> If you love newly built rental-home living with spacious two- and three-bedroom layouts, polished finishes, smart-home features, green space, and lawn maintenance made simple, invite a friend to experience it too. Send a referral and help them find their place here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Eleven Oaks.</strong><br>Log in to pay rent, submit maintenance requests, and manage your account with ease—so you can get back to enjoying newly built rental-home living, smart-home convenience, in-unit laundry, landscaped green space, and the everyday simplicity of lawn maintenance.</p>",
  "property_reviews_blurb": "<p><strong>Read the experience in residents’ own words.</strong> Your next home search gets clearer when you can see honest ratings and comments all in one place. Browse feedback from people who have called Eleven Oaks home, then use their perspectives to help picture everyday life at this Eustis rental-home community.</p><p>As you read through the reviews below, look for the details that matter most to you—from impressions of the homes and community spaces to the overall living experience. When you’re ready, the leasing team is available to help answer questions or schedule your visit.</p>",
  "property_created_at": "1785532352242",
  "property_scheduletour_blurb": "<p><strong>See newly built rental-home living up close.</strong> Tour Eleven Oaks to experience spacious two- and three-bedroom layouts, smart-home technology, polished finishes, landscaped green space, and everyday conveniences like in-unit laundry and lawn maintenance. Schedule your visit and picture the ease of Eustis living in person.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Our leasing team will follow up soon. In the meantime, picture newly built rental-home living with spacious two- and three-bedroom layouts, polished finishes, smart-home technology, in-unit laundry, and easy outdoor spaces that bring Eustis lake-country living home.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Eleven Oaks",
  "property_seo_title_home": "Eleven Oaks |  Apartments in Eustis, FL",
  "property_seo_description_home": "Elevate your lifestyle at Eleven Oaks in Eustis, FL, featuring spacious layouts, modern amenities, a private park, fire pit, and dog park!",
  "property_seo_title_floorplans": "Floor Plans | Eustis, FL Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Eleven Oaks in Eustis, FL. Choose from stylish two and three-bedroom layouts that fit your lifestyle. Browse our floor plans today!",
  "property_seo_title_amenities": "Amenities | Eustis, FL Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Eleven Oaks in Eustis, FL, with spacious apartments, a private park, dog park, and smart-home features!",
  "property_seo_title_gallery": "Gallery | Apartments in Eustis, FL",
  "property_seo_description_gallery": "Capture the charm of Eleven Oaks in Eustis, FL! Enjoy luxury finishes, a private park, and smart-home amenities. Picture your life here today!",
  "property_seo_title_virtualtours": "Virtual Tours | Eleven Oaks Apartments",
  "property_seo_description_virtualtours": "Step into Eleven Oaks in Eustis, FL! Take a virtual tour of our stunning two and three-bedroom apartments, designed for comfort and style.",
  "property_seo_title_interactivemap": "Interactive Map | Eleven Oaks Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Eleven Oaks in Eustis, FL! Use our interactive map to explore spacious floor plans, modern amenities, and a vibrant community vibe.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Eustis, FL",
  "property_seo_description_neighborhood": "Uncover the charm of Eustis, FL at Eleven Oaks. Discover local gems, vibrant parks, and essential conveniences just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Eleven Oaks",
  "property_seo_description_contact": "Reach out to Eleven Oaks in Eustis, FL! Inquire about our spacious two and three-bedroom floor plans. Your perfect home awaits—connect with our leasing team!",
  "property_seo_title_faqs": "FAQs | Apartments in Eustis, FL",
  "property_seo_description_faqs": "Find answers to your questions at Eleven Oaks in Eustis, FL. Discover luxury living with spacious floor plans, private parks, and top-notch amenities today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Eustis, FL",
  "property_seo_description_reviews": "At Eleven Oaks in Eustis, FL, residents enjoy spacious living, luxury amenities, and a vibrant community. Discover why they love calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Eustis, FL",
  "property_seo_description_applynow": "Elevate your lifestyle at Eleven Oaks in Eustis, FL! Enjoy luxury living with spacious floor plans, smart-home tech, and amazing amenities. Apply online now!",
  "property_seo_title_residentaccess": "Resident Access | Eleven Oaks",
  "property_seo_description_residentaccess": "Discover convenience at Eleven Oaks, Eustis, FL! Access your resident portal for rent payments, maintenance requests, and more at your fingertips.",
  "property_seo_title_referafriend": "Refer A Friend | Eleven Oaks",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Eleven Oaks in Eustis, FL, and share the joy of community living. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Eleven Oaks",
  "property_seo_description_scheduletour": "Experience the charm of Eleven Oaks in Eustis, FL. Schedule your tour today and step into a lifestyle that blends comfort and community!",
  "property_seo_title_privacy": "Privacy Policy | Eleven Oaks",
  "property_seo_description_privacy": "At Eleven Oaks, Eustis, FL, your privacy matters. Discover how we secure your information. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Eleven Oaks",
  "property_seo_description_accessibility": "At Eleven Oaks in Eustis, FL, we prioritize digital accessibility for all. Join our inclusive community where everyone feels at home. Your comfort matters!",
  "property_seo_title_sitemap": "Sitemap | Eleven Oaks",
  "property_seo_description_sitemap": "Navigate your journey at Eleven Oaks in Eustis, FL! Check out our sitemap for a seamless path to your future home sweet home. Your adventure awaits!",
  "property_seo_title_thankyou": "Thank You | Eleven Oaks",
  "property_seo_description_thankyou": "Thank you for contacting Eleven Oaks in Eustis, FL! Our team will reach out soon to help you find your ideal living space. Exciting options await!",
  "property_seo_title_pets": "Pet Policy | Apartments in Eustis, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793288317273",
  "amenities": [
    {
      "id": "ec_bbee09eb66e50dfe94b0b17c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "yardi",
      "external_id": "121410228",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_54dd5f062b03315daa0463ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "yardi",
      "external_id": "125950773",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52ab5d2c7ca8a40da2111f24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "yardi",
      "external_id": "121410226",
      "title": "Private Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a688e6bd1fd3480b8aa3e0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "yardi",
      "external_id": "121410220",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b930fdd2a8140c3b79e5ffb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "yardi",
      "external_id": "121410227",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d7c57de6862843cd7c301ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "yardi",
      "external_id": "121410221",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cbb2563e2060c8dc087134b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "yardi",
      "external_id": "121410222",
      "title": "Luxury Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_85489bf0f1bfce903010fb5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "yardi",
      "external_id": "121410223",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f744b2212dd6d10e254eb00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "yardi",
      "external_id": "121410224",
      "title": "Smart-Home Technology",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9cabe33d13537924663d741e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "yardi",
      "external_id": "121410225",
      "title": "Lawn Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_43e18984d2328f366333c08f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-d94c-7631-b6cb-b05be4161fc4.webp",
      "image_media": {
        "alt_text": "A single-family home with a beige exterior, attached two-car garage, and green lawn.",
        "public_id": "019fbdae-d94c-7631-b6cb-b05be4161fc4",
        "storage_key": "property/6767906449167576/019fbdae-d94c-7631-b6cb-b05be4161fc4.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Charming single-family home featuring a spacious two-car garage, inviting exterior, and well-maintained landscaping. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "a house with a garage door and a driveway",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_24_willowoakexteriorhomeev53xzeu_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_3e5997493e1676496904168e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-e37d-7401-a412-e76c42bbc032.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a large island.",
        "public_id": "019fbdae-e37d-7401-a412-e76c42bbc032",
        "storage_key": "property/6767906449167576/019fbdae-e37d-7401-a412-e76c42bbc032.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen, featuring sleek granite countertops, a full suite of stainless steel appliances, and a spacious island perfect for meal prep and casual dining.",
      "link": "false",
      "alt_text": "a kitchen with a granite counter top and a stainless steel refrigerator",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_10_elevenwillowkitchenhomevuq4w22a_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_4db3e57a3eefd38fd3fe1f93",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-e48d-704d-968f-1a5dfa917d93.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and island.",
        "public_id": "019fbdae-e48d-704d-968f-1a5dfa917d93",
        "storage_key": "property/6767906449167576/019fbdae-e48d-704d-968f-1a5dfa917d93.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring stainless steel appliances, granite countertops, and a large island, perfect for entertaining.",
      "link": "false",
      "alt_text": "an open kitchen and living room with a ceiling fan",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/eleven-willow-living-room-home-u5g3kr4a.jpg"
    },
    {
      "id": "ec_15ab40690dc3d6dcbd81007e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-e394-7784-90d2-0aee14967f0c.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with granite countertops and a large mirror.",
        "public_id": "019fbdae-e394-7784-90d2-0aee14967f0c",
        "storage_key": "property/6767906449167576/019fbdae-e394-7784-90d2-0aee14967f0c.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, ample storage, and a walk-in shower.",
      "link": "false",
      "alt_text": "a bathroom with a sink and a shower",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_5_bathhomehqmmxvki_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_f97e95c8f46838b49cf2f0bf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-e3bc-77a9-87e4-ae1a04f29392.webp",
      "image_media": {
        "alt_text": "Exterior of a single-family home with a two-car garage, front door, and manicured lawn.",
        "public_id": "019fbdae-e3bc-77a9-87e4-ae1a04f29392",
        "storage_key": "property/6767906449167576/019fbdae-e3bc-77a9-87e4-ae1a04f29392.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Charming single-family home featuring a spacious two-car garage, inviting front entrance, and well-maintained landscaping. Located in a desirable neighborhood.",
      "link": "false",
      "alt_text": "a white house with a yard and a garage door",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_7_chapmanexteriorhomehyshez5x_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_d14954b4eb1695e04e4ec957",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-e3c4-7710-8f83-c21bed291a3d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and white cabinets.",
        "public_id": "019fbdae-e3c4-7710-8f83-c21bed291a3d",
        "storage_key": "property/6767906449167576/019fbdae-e3c4-7710-8f83-c21bed291a3d.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek white cabinetry, durable granite countertops, and top-of-the-line stainless steel appliances for a refined cooking experience.",
      "link": "false",
      "alt_text": "a kitchen with white cabinets and granite counter tops",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_8_chapmankitchenhomemlb33ypu_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_c8a164b20456caa5ab959db0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-eb5f-724a-a549-9206603a908f.webp",
      "image_media": {
        "alt_text": "Open concept living area and kitchen with island, stainless steel appliances, and wood-look flooring.",
        "public_id": "019fbdae-eb5f-724a-a549-9206603a908f",
        "storage_key": "property/6767906449167576/019fbdae-eb5f-724a-a549-9206603a908f.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area flows into a modern kitchen featuring a large island, granite countertops, and stainless steel appliances. Perfect for entertaining.",
      "link": "false",
      "alt_text": "an empty living room with a kitchen and a ceiling fan",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_9_chapmanlivingroomhomemcziu5fy_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_fc3628765f28f197f8e101f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-eca8-7704-be2b-b41268006fdf.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop and white cabinets, adjacent to a walk-in shower.",
        "public_id": "019fbdae-eca8-7704-be2b-b41268006fdf",
        "storage_key": "property/6767906449167576/019fbdae-eca8-7704-be2b-b41268006fdf.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity with ample storage and a sleek walk-in shower, perfect for your daily routine.",
      "link": "false",
      "alt_text": "a bathroom with a sink and a shower and a mirror",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_6_chapmanbathroomhomekhvxjzcl_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_a186bee17710c94dd5f4c398",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-ed02-72f6-b589-cc450e20f199.webp",
      "image_media": {
        "alt_text": "Exterior view of a single-family home with a light tan facade, a beige garage door, and a well-maintained lawn.",
        "public_id": "019fbdae-ed02-72f6-b589-cc450e20f199",
        "storage_key": "property/6767906449167576/019fbdae-ed02-72f6-b589-cc450e20f199.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Charming single-family home featuring a welcoming entryway, a spacious garage, and lush landscaping, perfect for comfortable living.",
      "link": "false",
      "alt_text": "a house with a driveway and a garage door",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_13_laurelexteriorhomepuhfam4z_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_916cb5986f6d055c4e6acee1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-ed14-70cd-bdfd-73233ed043a5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a large island with a sink.",
        "public_id": "019fbdae-ed14-70cd-bdfd-73233ed043a5",
        "storage_key": "property/6767906449167576/019fbdae-ed14-70cd-bdfd-73233ed043a5.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring elegant white cabinetry, granite countertops, stainless steel appliances, and a large island perfect for meal preparation and entertaining.",
      "link": "false",
      "alt_text": "a kitchen with granite counter tops and a stainless steel refrigerator",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_14_laurelkitchenhomesr2qf3an_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_6ee58a4360c47b2f5882bee4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-ee96-7196-abc7-b8ef2483754f.webp",
      "image_media": {
        "alt_text": "Open-concept living room and kitchen with a sectional sofa, island, and modern appliances.",
        "public_id": "019fbdae-ee96-7196-abc7-b8ef2483754f",
        "storage_key": "property/6767906449167576/019fbdae-ee96-7196-abc7-b8ef2483754f.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a comfortable sectional sofa, a sleek kitchen with an island and modern appliances, and sliding glass doors leading to the outdoors.",
      "link": "false",
      "alt_text": "a living room with a couch and a ceiling fan",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_15_laurellivinghomermnpjqae_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_1fc2537fa03de39d7bd47091",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-f34b-7313-8553-82a926562cf5.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity and walk-in closet.",
        "public_id": "019fbdae-f34b-7313-8553-82a926562cf5",
        "storage_key": "property/6767906449167576/019fbdae-f34b-7313-8553-82a926562cf5.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops and ample storage, plus a walk-in closet.",
      "link": "false",
      "alt_text": "a bathroom with a sink and a mirror",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_12_laurelbathroomhome43l5qy04_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_042f144a8525f3b8b58f0990",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-f442-76fd-b6ee-00e23190e4fd.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with two front doors on each unit.",
        "public_id": "019fbdae-f442-76fd-b6ee-00e23190e4fd",
        "storage_key": "property/6767906449167576/019fbdae-f442-76fd-b6ee-00e23190e4fd.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Discover comfortable living with our charming apartment exteriors, featuring welcoming front porches and well-maintained landscaping.",
      "link": "false",
      "alt_text": "a large house with a sidewalk in front of it",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_2_banyanexteriorhome4n11qwkm_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_0b2f7ace6db29e757ea2ebe3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-f633-72eb-9ae9-8e751084e8e9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinetry.",
        "public_id": "019fbdae-f633-72eb-9ae9-8e751084e8e9",
        "storage_key": "property/6767906449167576/019fbdae-f633-72eb-9ae9-8e751084e8e9.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, and ample white cabinetry. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "a kitchen with an island and stainless steel refrigerator",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/eleven-banyan-kitchen-home-wdewvr1r.jpg"
    },
    {
      "id": "ec_43b39b7cacef38adf079e880",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-f603-747f-835b-e78301cbeec4.webp",
      "image_media": {
        "alt_text": "Living room with wood-look flooring, a ceiling fan, and stairs leading to another level.",
        "public_id": "019fbdae-f603-747f-835b-e78301cbeec4",
        "storage_key": "property/6767906449167576/019fbdae-f603-747f-835b-e78301cbeec4.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Spacious living area featuring modern wood-look flooring and a ceiling fan. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "an empty living room with a ceiling fan",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_4_banyanlivinghomes34lmt5r_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_bf1aef02cef05d355113faf7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-f6ca-7136-af46-b0241d16102c.webp",
      "image_media": {
        "alt_text": "White shower and toilet in a bathroom with granite countertop.",
        "public_id": "019fbdae-f6ca-7136-af46-b0241d16102c",
        "storage_key": "property/6767906449167576/019fbdae-f6ca-7136-af46-b0241d16102c.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a white walk-in shower, toilet, and vanity with a granite countertop.",
      "link": "false",
      "alt_text": "a bathroom with a toilet and a shower",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_1_banyanbathroomhomewa5ac4cr_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_b8e3a6006664a5b5245144be",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-fb7d-731d-92c7-06c7d19edfbd.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with two doors, 154 and 152 visible.",
        "public_id": "019fbdae-fb7d-731d-92c7-06c7d19edfbd",
        "storage_key": "property/6767906449167576/019fbdae-fb7d-731d-92c7-06c7d19edfbd.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings showing multiple units with covered entryways and fresh landscaping.",
      "link": "false",
      "alt_text": "a white house with a driveway and a lawn",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_21_whiteexteriorhome1flokfoe_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_04a5d6b0995c683cecf60821",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-fbd6-75e6-a86b-146ac3edc893.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops and stainless steel appliances.",
        "public_id": "019fbdae-fbd6-75e6-a86b-146ac3edc893",
        "storage_key": "property/6767906449167576/019fbdae-fbd6-75e6-a86b-146ac3edc893.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this spacious kitchen featuring granite countertops, stainless steel appliances, and a breakfast bar.",
      "link": "false",
      "alt_text": "a kitchen with a counter top and a",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_22_whitekitchenhomeyz1htmmp_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_6fa57aeeabe4332ef37ee82e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-fddf-73bc-b315-58027377587a.webp",
      "image_media": {
        "alt_text": "Living room with wood-look flooring, ceiling fan, and large window.",
        "public_id": "019fbdae-fddf-73bc-b315-58027377587a",
        "storage_key": "property/6767906449167576/019fbdae-fddf-73bc-b315-58027377587a.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Spacious living area with abundant natural light and modern finishes, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "an empty living room with wood floors and a ceiling fan",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_23_whitelivingroomhometohxc2ds_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_97f582624fc89fa8a0cc3184",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-fe54-738c-960d-16477f55de05.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and tub/shower combo.",
        "public_id": "019fbdae-fe54-738c-960d-16477f55de05",
        "storage_key": "property/6767906449167576/019fbdae-fe54-738c-960d-16477f55de05.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a single vanity with a granite countertop, a toilet, and a bathtub with a shower.",
      "link": "false",
      "alt_text": "a bathroom with a sink toilet and a shower",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_20_whitebathroomhomepu2qvazf_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_a1245f7b84e94404d802e00f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdae-ff46-7729-b038-d5c88cde0c02.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with two front doors.",
        "public_id": "019fbdae-ff46-7729-b038-d5c88cde0c02",
        "storage_key": "property/6767906449167576/019fbdae-ff46-7729-b038-d5c88cde0c02.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Community",
      "description": "The exterior of the apartment building shows two identical front doors with porch lights and house numbers 142 and 140.",
      "link": "false",
      "alt_text": "a white house with a driveway and a lawn",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_17_scarletexteriorhomenx5iuy0l_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_8eda190dfa67e4392adbc019",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-0351-73da-b0d8-e9724057e7f4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a large island.",
        "public_id": "019fbdaf-0351-73da-b0d8-e9724057e7f4",
        "storage_key": "property/6767906449167576/019fbdaf-0351-73da-b0d8-e9724057e7f4.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, elegant granite countertops, stainless steel appliances, and a convenient island with a sink and faucet.",
      "link": "false",
      "alt_text": "a kitchen with a granite counter top and a stainless steel refrigerator",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_18_scarletkitchenhomedgyhehfm_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_a19bc0dfac8d90f78e566761",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-03c2-70fb-9d26-cbddc0eb64c8.webp",
      "image_media": {
        "alt_text": "Spacious living room with wood-look flooring, a ceiling fan, and a staircase leading upstairs.",
        "public_id": "019fbdaf-03c2-70fb-9d26-cbddc0eb64c8",
        "storage_key": "property/6767906449167576/019fbdaf-03c2-70fb-9d26-cbddc0eb64c8.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "Bright and airy living space with neutral walls, wood-look flooring, and ample natural light. Features a ceiling fan and access to an upstairs area.",
      "link": "false",
      "alt_text": "an empty living room with a ceiling fan and wood floors",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_19_scarletlivingroomhomeocfvwp4v_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_ea8086a245783bce21d84fc7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-0571-735e-bc19-a689a4d130a1.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, shower, toilet, and vanity.",
        "public_id": "019fbdaf-0571-735e-bc19-a689a4d130a1",
        "storage_key": "property/6767906449167576/019fbdaf-0571-735e-bc19-a689a4d130a1.webp",
        "width": 1024,
        "height": 768
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub with an overhead shower, a toilet, and a vanity with a granite countertop.",
      "link": "false",
      "alt_text": "a bathroom with a toilet and a bath tub",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/FL_Eustis_ElevenOaks_p1630010_16_scarletbathroomhomefoh2slog_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_f08a6527e80ca33027b1c477",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-3777-768f-bf03-2a49ee2e6429.webp",
      "image_media": {
        "alt_text": "Fenced dog park area with trees and benches.",
        "public_id": "019fbdaf-3777-768f-bf03-2a49ee2e6429",
        "storage_key": "property/6767906449167576/019fbdaf-3777-768f-bf03-2a49ee2e6429.webp",
        "width": 3072,
        "height": 2302
      },
      "title": "Community",
      "description": "Enjoy our spacious, fenced dog park, perfect for your furry friends to run and play. Amenities include waste stations and shaded areas under large oak trees.",
      "link": "false",
      "alt_text": "A fenced area with a tree and a green container.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Eleven-Oaks-Dog-Park%20(4).jpg"
    },
    {
      "id": "ec_a43cab59dd9e5bcd94febcdc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-35a6-74dd-a3c2-25dbe763a301.webp",
      "image_media": {
        "alt_text": "Fenced-in dog park with mulch ground, picnic table, and waste station under large oak trees.",
        "public_id": "019fbdaf-35a6-74dd-a3c2-25dbe763a301",
        "storage_key": "property/6767906449167576/019fbdaf-35a6-74dd-a3c2-25dbe763a301.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy our spacious, fenced-in dog park, complete with mulch ground, a picnic table, and a waste station, all shaded by beautiful, mature oak trees. A perfect spot for your furry friends to play and socialize.",
      "link": "false",
      "alt_text": "A tree with hanging moss is in the foreground of a fenced area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Eleven-Oaks-Dog-Park%20(3).jpg"
    },
    {
      "id": "ec_bf370848bac1aadac6580b68",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-29d9-749b-9dcf-be79c8780ad9.webp",
      "image_media": {
        "alt_text": "Playground with swings and slides in a residential area.",
        "public_id": "019fbdaf-29d9-749b-9dcf-be79c8780ad9",
        "storage_key": "property/6767906449167576/019fbdaf-29d9-749b-9dcf-be79c8780ad9.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring swings and slides perfect for children's recreation.",
      "link": "false",
      "alt_text": "A playground with a slide and swings in a grassy area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Eleven-Oaks-Playground%20(2).jpg"
    },
    {
      "id": "ec_bcce2557503c0dd5ed295a94",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-45f3-723e-a5c9-d00fdfcbb68b.webp",
      "image_media": {
        "alt_text": "Dog park with wood chip ground cover and black chain-link fencing.",
        "public_id": "019fbdaf-45f3-723e-a5c9-d00fdfcbb68b",
        "storage_key": "property/6767906449167576/019fbdaf-45f3-723e-a5c9-d00fdfcbb68b.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "A dedicated dog park area with wood chip surfacing, surrounded by black chain-link fencing, providing a safe space for pets to play and exercise.",
      "link": "false",
      "alt_text": "A fenced in area with a dirt ground and trees in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Eleven-Oaks-Dog-Park%20(5).jpg"
    },
    {
      "id": "ec_66c298231e0f73eb245226d4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-377f-70bc-9d82-6178075b0a79.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fire pit, Adirondack chairs, picnic table, and grills.",
        "public_id": "019fbdaf-377f-70bc-9d82-6178075b0a79",
        "storage_key": "property/6767906449167576/019fbdaf-377f-70bc-9d82-6178075b0a79.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community's picnic and grilling areas, featuring a fire pit and comfortable seating.",
      "link": "false",
      "alt_text": "A concrete patio with blue chairs and a table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Eleven-Oaks-Firepit%20(2).jpg"
    },
    {
      "id": "ec_ad2cb0b94b34ec9f26d2b7a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-6c98-7499-af17-e3e4ae7d0d93.webp",
      "image_media": {
        "alt_text": "Aerial view of a newly developed neighborhood with multiple apartment buildings and single-family homes.",
        "public_id": "019fbdaf-6c98-7499-af17-e3e4ae7d0d93",
        "storage_key": "property/6767906449167576/019fbdaf-6c98-7499-af17-e3e4ae7d0d93.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Discover this vibrant community featuring modern apartment buildings and charming single-family homes, all surrounded by lush greenery and convenient amenities.",
      "link": "false",
      "alt_text": "Aerial view of a newly developed neighborhood with multiple apartment buildings and single-family homes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Eleven-Oaks-Aerial-September-2024-5.jpg"
    },
    {
      "id": "ec_b2d6e24eb31cd54628b9eaa0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-791d-714b-a783-dbf2bcf4f488.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with multiple apartment buildings and houses.",
        "public_id": "019fbdaf-791d-714b-a783-dbf2bcf4f488",
        "storage_key": "property/6767906449167576/019fbdaf-791d-714b-a783-dbf2bcf4f488.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "An aerial perspective showcases a well-planned suburban community, featuring apartment complexes and residential homes with neatly arranged streets and green spaces.",
      "link": "false",
      "alt_text": "A bird's eye view of a residential area with houses, roads, and greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Eleven-Oaks-Aerial-September-2024-5(1).jpg"
    },
    {
      "id": "ec_29bff04d4adf90f857f2c2e6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-7f1e-740d-a023-545b64e98607.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with manicured lawns and walking paths.",
        "public_id": "019fbdaf-7f1e-740d-a023-545b64e98607",
        "storage_key": "property/6767906449167576/019fbdaf-7f1e-740d-a023-545b64e98607.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Experience comfortable living in our beautifully landscaped community, featuring modern apartment buildings with lush green spaces and convenient walking paths.",
      "link": "false",
      "alt_text": "A large grassy area with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Eleven-Oaks-Aerial-September-2024-1(1).jpg"
    },
    {
      "id": "ec_3e8e8ec6f3d8fb804291c0f9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-8720-7763-9d08-a4da8a2db23e.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with colorful houses and a playground.",
        "public_id": "019fbdaf-8720-7763-9d08-a4da8a2db23e",
        "storage_key": "property/6767906449167576/019fbdaf-8720-7763-9d08-a4da8a2db23e.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Discover a vibrant community with charming homes, a children's playground, and tree-lined streets. Ideal for family living and outdoor enjoyment.",
      "link": "false",
      "alt_text": "A suburban neighborhood with houses and parked cars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Eleven-Oaks-Aerial-September-2024-2.jpg"
    },
    {
      "id": "ec_37f132790a6650fcdbaada30",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fbdaf-a4cc-74d3-8392-466576a1fff0.webp",
      "image_media": {
        "alt_text": "Aerial view of a townhouse community with multiple buildings, a curved road, and a central green space.",
        "public_id": "019fbdaf-a4cc-74d3-8392-466576a1fff0",
        "storage_key": "property/6767906449167576/019fbdaf-a4cc-74d3-8392-466576a1fff0.webp",
        "width": 3072,
        "height": 2302
      },
      "title": "Community",
      "description": "Discover this vibrant townhouse community from an aerial perspective, showcasing modern architecture, lush landscaping, and ample green spaces for recreation and relaxation.",
      "link": "false",
      "alt_text": "A bird's eye view of a residential area with houses and a park.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Eleven-Oaks-Aerial-September-2024-3(1).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_4fcd83ba-ef74-4e65-b675-027c99abf591",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "One Thirteen Coffeehouse",
      "poi_type": "Restaurants",
      "poi_address": "113 N Bay St, Eustis, FL 32726, USA",
      "poi_short_description": "Cozy cafe serving coffee, cakes and sweets in a relaxing space.",
      "poi_long_description": "Cozy cafe serving coffee, cakes and sweets in a relaxing space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-e751-77ab-a368-91979e0a53eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-e751-77ab-a368-91979e0a53eb",
        "storage_key": "property/6767906449167576/019fba07-e751-77ab-a368-91979e0a53eb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://one-thirteen-coffeehouse.square.site/?location_id=LGPGE3GPC0BW4&fulfillment=PICKUP",
      "poi_directions_map_url": "https://maps.google.com/?cid=11941776787504308440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "one-thirteen-coffeehouse",
      "poi_latitude": "28.8540046",
      "poi_longitude": "-81.6854642",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 352-360-5362",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2f24-718a-a8f1-fbf3df4d88d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-2f24-718a-a8f1-fbf3df4d88d8",
        "storage_key": "property/6767906449167576/019fba08-2f24-718a-a8f1-fbf3df4d88d8.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJC3e01f-j54gR2CAzzre2uaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_38500073-0bfa-470a-8a8d-53a2c4c9fc77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Rosa Mezcal Cocina Mexicana",
      "poi_type": "Restaurants",
      "poi_address": "12 E Magnolia Ave, Eustis, FL 32726, USA",
      "poi_short_description": "Casual fixture dishing up authentic Mexican staples from tacos to fajitas to guac, plus chips and salsa.",
      "poi_long_description": "Casual fixture dishing up authentic Mexican staples from tacos to fajitas to guac, plus chips and salsa.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-e750-765a-8965-b358959a0637.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-e750-765a-8965-b358959a0637",
        "storage_key": "property/6767906449167576/019fba07-e750-765a-8965-b358959a0637.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rosamezcalmex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16081294937046889816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosa-mezcal-cocina-mexicana",
      "poi_latitude": "28.8533462",
      "poi_longitude": "-81.6853735",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 352-308-8042",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbdb-75fb-9434-1574773b4740",
        "storage_key": "property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx5pcTAej54gRWLX3-oo8LN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_7be33fdb-6b8b-4089-9871-7a4192fdff7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "The Brick & Barrel Kitchen + Bar",
      "poi_type": "Restaurants",
      "poi_address": "31 E Magnolia Ave, Eustis, FL 32726, USA",
      "poi_short_description": "American eats and craft beers served in a casual setting with live music on weekends.",
      "poi_long_description": "American eats and craft beers served in a casual setting with live music on weekends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-eb4c-77c8-b4c6-29e38ec0ad77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-eb4c-77c8-b4c6-29e38ec0ad77",
        "storage_key": "property/6767906449167576/019fba07-eb4c-77c8-b4c6-29e38ec0ad77.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brickandbarrelfl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10363243926782610745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-brick--barrel-kitchen--bar",
      "poi_latitude": "28.853822",
      "poi_longitude": "-81.68475",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 352-602-4227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbdb-75fb-9434-1574773b4740",
        "storage_key": "property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB0o-IQmj54gROQ2a0HGj0Y8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a3c466f2-40af-4909-8f9c-1368fd77a938",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "The Great Pizza Company",
      "poi_type": "Restaurants",
      "poi_address": "23 E Magnolia Ave, Eustis, FL 32726, USA",
      "poi_short_description": "Compact pizzeria featuring thin-crust pies, pasta dishes & sandwiches, plus limited outdoor seating.",
      "poi_long_description": "Compact pizzeria featuring thin-crust pies, pasta dishes & sandwiches, plus limited outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-ecf2-726a-9ffd-8592ca749312.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-ecf2-726a-9ffd-8592ca749312",
        "storage_key": "property/6767906449167576/019fba07-ecf2-726a-9ffd-8592ca749312.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4383228765744897683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-great-pizza-company",
      "poi_latitude": "28.853776",
      "poi_longitude": "-81.685114",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 352-357-7377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbdb-75fb-9434-1574773b4740",
        "storage_key": "property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB7RFrjaj54gRk55_z1Zb1Dw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_0e768c4b-8990-4672-b647-bf8d6a613496",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Sol De Mexico",
      "poi_type": "Restaurants",
      "poi_address": "125 N Bay St, Eustis, FL 32726, USA",
      "poi_short_description": "Family-run Mexican cantina decked out with South American furniture & artworks, open since 2009.",
      "poi_long_description": "Family-run Mexican cantina decked out with South American furniture & artworks, open since 2009.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-e69c-7519-b4dc-e6d12b207782.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-e69c-7519-b4dc-e6d12b207782",
        "storage_key": "property/6767906449167576/019fba07-e69c-7519-b4dc-e6d12b207782.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.soldemexicorestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11717077452040735762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sol-de-mexico",
      "poi_latitude": "28.8542189",
      "poi_longitude": "-81.685437",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 352-357-0259",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbdb-75fb-9434-1574773b4740",
        "storage_key": "property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwS13pjaj54gREoyg5txrm6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_d602a3c6-a071-4721-b934-098e536181c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Wolf Branch Brewing - Eustis",
      "poi_type": "Restaurants",
      "poi_address": "119 N Bay St, Eustis, FL 32726, USA",
      "poi_short_description": "Craft brewery and taproom on N Bay Street in downtown Eustis.",
      "poi_long_description": "Craft brewery and taproom on N Bay Street in downtown Eustis.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-edc4-7271-b8b5-85858b14a083.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-edc4-7271-b8b5-85858b14a083",
        "storage_key": "property/6767906449167576/019fba07-edc4-7271-b8b5-85858b14a083.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://wolfbranchbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9901585700002835766&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wolf-branch-brewing---eustis",
      "poi_latitude": "28.8541288",
      "poi_longitude": "-81.6855313",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 407-276-1510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbef-738b-bd3e-b8b8df6451f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbef-738b-bd3e-b8b8df6451f5",
        "storage_key": "property/6767906449167576/019fba05-cbef-738b-bd3e-b8b8df6451f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdbvQpzaj54gRNq3Bubt_aYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_2192aac5-c607-4121-aee7-bd851a15c924",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Lake Eustis Waterfront Grille",
      "poi_type": "Restaurants",
      "poi_address": "350 Lakeshore Dr, Eustis, FL 32726, USA",
      "poi_short_description": "Relaxed eatery featuring seafood platters burgers and steaks as well as lakeside views.",
      "poi_long_description": "Relaxed eatery featuring seafood platters burgers and steaks as well as lakeside views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-916f-7721-b9ce-5a93cc9c00a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba05-916f-7721-b9ce-5a93cc9c00a5",
        "storage_key": "property/6767906449167576/019fba05-916f-7721-b9ce-5a93cc9c00a5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lakeeustiswaterfront.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4025298107211767703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-eustis-waterfront-grille",
      "poi_latitude": "28.8519283",
      "poi_longitude": "-81.6893721",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 352-602-7446",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbdb-75fb-9434-1574773b4740",
        "storage_key": "property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu7qbwVmj54gRl99oM0273Dc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_13238dab-d0c3-401c-ab63-cad76ec6b4e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "The Troff",
      "poi_type": "Restaurants",
      "poi_address": "936 N Bay St, Eustis, FL 32726, USA",
      "poi_short_description": "Old-school eatery specializing in oysters, seafood & other American fare, plus pitchers of beer.",
      "poi_long_description": "Old-school eatery specializing in oysters, seafood & other American fare, plus pitchers of beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-e208-739e-afa1-416fb6ea8e7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-e208-739e-afa1-416fb6ea8e7a",
        "storage_key": "property/6767906449167576/019fba07-e208-739e-afa1-416fb6ea8e7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thetroff.net/?utm_source=googlemybusiness",
      "poi_directions_map_url": "https://maps.google.com/?cid=10250872786819465491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-troff",
      "poi_latitude": "28.8625977",
      "poi_longitude": "-81.6863164",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 352-357-9939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbdb-75fb-9434-1574773b4740",
        "storage_key": "property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD12IK0qj54gRE8EX-HxqQo4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_c104b47e-8ee4-49d3-819f-efe5eb4f6599",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Stavro's and Sons Pizza",
      "poi_type": "Restaurants",
      "poi_address": "2100 County Rd 44, Eustis, FL 32726, USA",
      "poi_short_description": "Simple standby for classic Italian, Greek &  Mediterranean cooking served in warm, homey environs.",
      "poi_long_description": "Simple standby for classic Italian, Greek &  Mediterranean cooking served in warm, homey environs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-e210-7129-948b-15dc6f1df976.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-e210-7129-948b-15dc6f1df976",
        "storage_key": "property/6767906449167576/019fba07-e210-7129-948b-15dc6f1df976.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://stavrosandsons.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8405059363974872960&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stavros-and-sons-pizza",
      "poi_latitude": "28.8743759",
      "poi_longitude": "-81.69941229999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 352-589-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbdb-75fb-9434-1574773b4740",
        "storage_key": "property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq9e-qq-854gRgP_KqfXEpHQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_b48dee2d-b83c-446a-abbd-f3ba0c0137b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Oakwood Smokehouse & Grill",
      "poi_type": "Restaurants",
      "poi_address": "2911 David Walker Dr, Eustis, FL 32726, USA",
      "poi_short_description": "Local BBQ chain serving ribs, steakburgers, seafood & Southern sides in a relaxed atmosphere.",
      "poi_long_description": "Local BBQ chain serving ribs, steakburgers, seafood & Southern sides in a relaxed atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-e69d-753d-9e38-14963aa9ec81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-e69d-753d-9e38-14963aa9ec81",
        "storage_key": "property/6767906449167576/019fba07-e69d-753d-9e38-14963aa9ec81.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://oakwoodsmokehouseeustis.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=8756609562684171484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oakwood-smokehouse--grill",
      "poi_latitude": "28.8234112",
      "poi_longitude": "-81.7012926",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 352-483-0137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbdb-75fb-9434-1574773b4740",
        "storage_key": "property/6767906449167576/019fba05-cbdb-75fb-9434-1574773b4740.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn6SXbzC954gR3CSUtAC6hXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_dcdb6c6f-b351-4c37-bf52-306e8cec753f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "2754 E Orange Ave, Eustis, FL 32726, USA",
      "poi_short_description": "Convenience store and fuel station on E Orange Avenue, the closest stop to the community.",
      "poi_long_description": "Convenience store and fuel station on E Orange Avenue, the closest stop to the community.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-f253-75ed-9651-15acff385df1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-f253-75ed-9651-15acff385df1",
        "storage_key": "property/6767906449167576/019fba07-f253-75ed-9651-15acff385df1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/eustis/2754-e-orange-ave/2726233?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=18093401386691557539&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "28.8524514",
      "poi_longitude": "-81.6542595",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 352-589-6776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2ee8-7243-9815-b9e874eff460.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-2ee8-7243-9815-b9e874eff460",
        "storage_key": "property/6767906449167576/019fba08-2ee8-7243-9815-b9e874eff460.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJj-oJPgyj54gRo3hPwLKsGPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_728ee6b2-d15c-4b2a-aeb3-2e8e25b622ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "2640 E Orange Ave, Eustis, FL 32726, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-f194-702c-8427-442ad528a1d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-f194-702c-8427-442ad528a1d4",
        "storage_key": "property/6767906449167576/019fba07-f194-702c-8427-442ad528a1d4.webp",
        "width": 427,
        "height": 640
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/fl/eustis/14553",
      "poi_directions_map_url": "https://maps.google.com/?cid=16566267674385685327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "28.85262539999999",
      "poi_longitude": "-81.6564051",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 352-434-0390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2ee9-76ad-8851-6d8c2e4673fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-2ee9-76ad-8851-6d8c2e4673fb",
        "storage_key": "property/6767906449167576/019fba08-2ee9-76ad-8851-6d8c2e4673fb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2b_4SQyj54gRT5vLka005-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_56ff8850-7bfb-44ed-95b6-f5b84efc632b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "17395 US-441, Eustis, FL 32726, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-9612-73af-9730-e8e73ce07795.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba05-9612-73af-9730-e8e73ce07795",
        "storage_key": "property/6767906449167576/019fba05-9612-73af-9730-e8e73ce07795.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/fl/eustis/17395-u-s-highway-441/l758",
      "poi_directions_map_url": "https://maps.google.com/?cid=5155186537202302003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "28.821486",
      "poi_longitude": "-81.669173",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbdf-763c-9595-e4875dd95808.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbdf-763c-9595-e4875dd95808",
        "storage_key": "property/6767906449167576/019fba05-cbdf-763c-9595-e4875dd95808.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ReB98Ki54gRM7zRnNfmikc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_dde47500-a9c8-424a-9fea-3787f1ac80d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Wildwood Antique Mall Of Eustis",
      "poi_type": "Shopping & Retail",
      "poi_address": "349 Plaza Dr, Eustis, FL 32726, USA",
      "poi_short_description": "Large vintage store featuring 100+ dealers selling furniture, jewelry and collectibles.",
      "poi_long_description": "Large vintage store featuring 100+ dealers selling furniture, jewelry and collectibles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-f412-71cc-9552-a37572323fad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-f412-71cc-9552-a37572323fad",
        "storage_key": "property/6767906449167576/019fba07-f412-71cc-9552-a37572323fad.webp",
        "width": 1280,
        "height": 443
      },
      "poi_business_url": "http://www.treasuremarts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3243722180575763705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wildwood-antique-mall-of-eustis",
      "poi_latitude": "28.823995",
      "poi_longitude": "-81.68799489999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 352-602-7536",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2ee9-76ad-8851-6d8c2e4673fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-2ee9-76ad-8851-6d8c2e4673fb",
        "storage_key": "property/6767906449167576/019fba08-2ee9-76ad-8851-6d8c2e4673fb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ57XeN3Gj54gR-RxGIyMEBC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_9d6648db-52a8-4e40-aa18-ae9f82292d0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Publix Super Market at Eustis Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "2840 David Walker Dr, Eustis, FL 32726, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-94d1-7119-b32d-b19272a9202f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba05-94d1-7119-b32d-b19272a9202f",
        "storage_key": "property/6767906449167576/019fba05-94d1-7119-b32d-b19272a9202f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=862&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=16817494754791709996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-eustis-village",
      "poi_latitude": "28.8239572",
      "poi_longitude": "-81.704413",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 352-357-6948",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbdf-763c-9595-e4875dd95808.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbdf-763c-9595-e4875dd95808",
        "storage_key": "property/6767906449167576/019fba05-cbdf-763c-9595-e4875dd95808.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1AfdjC954gRLN1aZ2C-Y-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_b306177c-54af-4b99-aea6-38e538fdf0d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Eustis Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "1300 E Orange Ave, Eustis, FL 32726, USA",
      "poi_short_description": "Yoga studio on E Orange Avenue in Eustis.",
      "poi_long_description": "Yoga studio on E Orange Avenue in Eustis.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-0aed-745c-8842-f7a61ed8246f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-0aed-745c-8842-f7a61ed8246f",
        "storage_key": "property/6767906449167576/019fba08-0aed-745c-8842-f7a61ed8246f.webp",
        "width": 900,
        "height": 1173
      },
      "poi_business_url": "http://eustisyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15906327101940634178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eustis-yoga",
      "poi_latitude": "28.852627",
      "poi_longitude": "-81.6717796",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 352-978-8356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-2ee9-76ad-8851-6881366b538f",
        "storage_key": "property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8ZB0fz6j54gRQhJXUDmgvtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_17dafe56-5b6a-4fdb-9cba-86d766f65471",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "TriPower Strength & Conditioning",
      "poi_type": "Health and Wellness",
      "poi_address": "231 N Grove St, Eustis, FL 32726, USA",
      "poi_short_description": "Welcoming gym with clean surroundings that holds classes and workshops in nutrition.",
      "poi_long_description": "Welcoming gym with clean surroundings that holds classes and workshops in nutrition.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-0f49-750a-a11f-709832b858f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-0f49-750a-a11f-709832b858f2",
        "storage_key": "property/6767906449167576/019fba08-0f49-750a-a11f-709832b858f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tripowersc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4345331998798345790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tripower-strength--conditioning",
      "poi_latitude": "28.8552818",
      "poi_longitude": "-81.683323",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 352-309-1045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbef-738b-bd3e-b8b8df6451f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbef-738b-bd3e-b8b8df6451f5",
        "storage_key": "property/6767906449167576/019fba05-cbef-738b-bd3e-b8b8df6451f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6epYfi6954gRPnaDK264TTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_bf602e0b-7594-4895-a76d-afac8517b9f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2005 FL-19, Eustis, FL 32726, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-09b4-70f9-8845-1478b1f2723e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-09b4-70f9-8845-1478b1f2723e",
        "storage_key": "property/6767906449167576/019fba08-09b4-70f9-8845-1478b1f2723e.webp",
        "width": 1280,
        "height": 749
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2005+n+highway+19-eustis-fl-32726/id=5809",
      "poi_directions_map_url": "https://maps.google.com/?cid=6794585986160913667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "28.8759493",
      "poi_longitude": "-81.686988",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 352-483-6183",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2eeb-71bd-aeb7-a35aa1294228.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-2eeb-71bd-aeb7-a35aa1294228",
        "storage_key": "property/6767906449167576/019fba08-2eeb-71bd-aeb7-a35aa1294228.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Xuk8lOj54gRA-33hPQ3S14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_a6f9dbcf-36f9-4ff6-96bd-ff105acd9c5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "UF Health Emergency & Urgent Care Center - Eustis/Mt. Dora",
      "poi_type": "Health and Wellness",
      "poi_address": "17021 US-441, Mt Dora, FL 32757, USA",
      "poi_short_description": "UF Health freestanding emergency room and urgent care on US-441.",
      "poi_long_description": "UF Health freestanding emergency room and urgent care on US-441.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-0f28-706e-88ff-aa8c83ce4da3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-0f28-706e-88ff-aa8c83ce4da3",
        "storage_key": "property/6767906449167576/019fba08-0f28-706e-88ff-aa8c83ce4da3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://central-florida-er.ufhealth.org/locations/uf-health-emergency-urgent-care-center-eustis-mo/?utm_source=loclistings&utm_medium=organic&y_source=1_MTA1MTk2OTM0OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17658974595115459604&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uf-health-emergency--urgent-care-center---eustismt-dora",
      "poi_latitude": "28.8214443",
      "poi_longitude": "-81.6744221",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 352-720-7999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbef-738b-bd3e-b8b8df6451f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbef-738b-bd3e-b8b8df6451f5",
        "storage_key": "property/6767906449167576/019fba05-cbef-738b-bd3e-b8b8df6451f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyacBFc-j54gRFCSBP9VHEfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_381130b2-30cf-4ce5-bda6-c1411fd1c6ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2830 S Bay St, Eustis, FL 32726, USA",
      "poi_short_description": "Chain fitness center offering tanning beds and hydromassage, plus a locker room, and showers.",
      "poi_long_description": "Chain fitness center offering tanning beds and hydromassage, plus a locker room, and showers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-a016-72b1-afc5-0b1bd56cf3dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba05-a016-72b1-afc5-0b1bd56cf3dd",
        "storage_key": "property/6767906449167576/019fba05-a016-72b1-afc5-0b1bd56cf3dd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/eustis-fl?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17077602128131953251&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "28.8258296",
      "poi_longitude": "-81.6873837",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 352-308-8907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbef-738b-bd3e-b8b8df6451f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbef-738b-bd3e-b8b8df6451f5",
        "storage_key": "property/6767906449167576/019fba05-cbef-738b-bd3e-b8b8df6451f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt_AuM9Ki54gRY5LCjqfU_-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3eefb931-bdc7-4b2e-bf2c-be70548e9ebd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "AdventHealth Waterman",
      "poi_type": "Health and Wellness",
      "poi_address": "1000 Waterman Way, Tavares, FL 32778, USA",
      "poi_short_description": "Full-service AdventHealth hospital in Tavares with a 24-hour emergency department.",
      "poi_long_description": "Full-service AdventHealth hospital in Tavares with a 24-hour emergency department.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-ab28-717c-a581-afc76cf3620b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba05-ab28-717c-a581-afc76cf3620b",
        "storage_key": "property/6767906449167576/019fba05-ab28-717c-a581-afc76cf3620b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.adventhealth.com/hospital/adventhealth-waterman",
      "poi_directions_map_url": "https://maps.google.com/?cid=17675997871391445108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-waterman",
      "poi_latitude": "28.8237321",
      "poi_longitude": "-81.71195159999999",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 352-253-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbfe-710d-a6ec-1739309f9079.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbfe-710d-a6ec-1739309f9079",
        "storage_key": "property/6767906449167576/019fba05-cbfe-710d-a6ec-1739309f9079.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLc80bHm954gRdBDZnmnCTfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_12afbd93-7bbb-46c2-8ef4-ea642a25f6e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Eustis Middle School",
      "poi_type": "Education",
      "poi_address": "18725 Bates Ave, Eustis, FL 32736, USA",
      "poi_short_description": "Public middle school, Lake County Schools.",
      "poi_long_description": "Public middle school, Lake County Schools.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ems.lake.k12.fl.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12590148105623412001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eustis-middle-school",
      "poi_latitude": "28.8590077",
      "poi_longitude": "-81.64626299999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 352-357-3366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-2ee9-76ad-8851-6881366b538f",
        "storage_key": "property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCxVy3p-j54gRIZ09If8wua4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_14865c23-4932-4d32-9fa3-16a388207f6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Eustis High School",
      "poi_type": "Education",
      "poi_address": "1300 E Washington Ave, Eustis, FL 32726, USA",
      "poi_short_description": "Public high school, Lake County Schools.",
      "poi_long_description": "Public high school, Lake County Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-f704-768e-a006-8fb07f0b0f81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-f704-768e-a006-8fb07f0b0f81",
        "storage_key": "property/6767906449167576/019fba07-f704-768e-a006-8fb07f0b0f81.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ehs.lake.k12.fl.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14064574792481291064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eustis-high-school",
      "poi_latitude": "28.8469714",
      "poi_longitude": "-81.6722376",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 352-357-4147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-2ee9-76ad-8851-6881366b538f",
        "storage_key": "property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoUL41jyj54gROLvCpkFoL8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_e2a2b0f8-f7f6-41bd-a6b3-0d92bbca13b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Eustis Elementary School",
      "poi_type": "Education",
      "poi_address": "714 Citrus Ave, Eustis, FL 32726, USA",
      "poi_short_description": "Public elementary school, Lake County Schools.",
      "poi_long_description": "Public elementary school, Lake County Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-f4b0-74b9-97f0-4e9e5ae416f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-f4b0-74b9-97f0-4e9e5ae416f1",
        "storage_key": "property/6767906449167576/019fba07-f4b0-74b9-97f0-4e9e5ae416f1.webp",
        "width": 1280,
        "height": 870
      },
      "poi_business_url": "https://eel.lake.k12.fl.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12175931541881225782&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eustis-elementary-school",
      "poi_latitude": "28.8510984",
      "poi_longitude": "-81.6778097",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 352-357-2779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-2ee9-76ad-8851-6881366b538f",
        "storage_key": "property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9SbkNDqj54gRNgJO-zmZ-ag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6ed7068c-c0dc-4fbb-803c-9f6eb43ae487",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Lake Technical College",
      "poi_type": "Education",
      "poi_address": "2001 Kurt St, Eustis, FL 32726, USA",
      "poi_short_description": "Public technical college in Eustis offering career and adult education programs.",
      "poi_long_description": "Public technical college in Eustis offering career and adult education programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-f878-709e-bcae-21a608468eed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-f878-709e-bcae-21a608468eed",
        "storage_key": "property/6767906449167576/019fba07-f878-709e-bcae-21a608468eed.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.laketech.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2760585936543839353&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-technical-college",
      "poi_latitude": "28.833443",
      "poi_longitude": "-81.6909072",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 352-589-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-2ee9-76ad-8851-6881366b538f",
        "storage_key": "property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIbpr0Cq954gReXSid0iSTyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_61aa4686-e70a-4a98-b5df-61fb2c24ca2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Dots Tots Preschool LLC",
      "poi_type": "Education",
      "poi_address": "628 S Bay St, Eustis, FL 32726, USA",
      "poi_short_description": "Licensed preschool on S Bay Street in Eustis.",
      "poi_long_description": "Licensed preschool on S Bay Street in Eustis.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-fffc-73e4-a743-ba3885c372f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-fffc-73e4-a743-ba3885c372f5",
        "storage_key": "property/6767906449167576/019fba07-fffc-73e4-a743-ba3885c372f5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://dotstotspreschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6808644573862246241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dots-tots-preschool-llc",
      "poi_latitude": "28.8468454",
      "poi_longitude": "-81.6859482",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 352-973-7899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-2ee9-76ad-8851-6881366b538f",
        "storage_key": "property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw0cif3yj54gRYTfziioqfV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_a6cdf4c3-b479-4aa7-9710-3ba49d69b361",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Bay Street Schoolhouse",
      "poi_type": "Education",
      "poi_address": "2405 S Bay St, Eustis, FL 32726, USA",
      "poi_short_description": "Child care and early-learning center on S Bay Street in Eustis.",
      "poi_long_description": "Child care and early-learning center on S Bay Street in Eustis.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-fb75-72ee-a012-d07e819ae0bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-fb75-72ee-a012-d07e819ae0bc",
        "storage_key": "property/6767906449167576/019fba07-fb75-72ee-a012-d07e819ae0bc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.baystreetschoolhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2470897774127805931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-street-schoolhouse",
      "poi_latitude": "28.8312655",
      "poi_longitude": "-81.6851221",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 352-483-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-2ee9-76ad-8851-6881366b538f",
        "storage_key": "property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv8pTjraj54gR6_UwJ29kSiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_c11be940-4cb0-48b1-8f63-5719ae1f1e87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Lake County Schools",
      "poi_type": "Education",
      "poi_address": "201 W Burleigh Blvd, Tavares, FL 32778, USA",
      "poi_short_description": "Lake County public school district office in Tavares.",
      "poi_long_description": "Lake County public school district office in Tavares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2702-70a8-b5da-3c27223c8f3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-2702-70a8-b5da-3c27223c8f3c",
        "storage_key": "property/6767906449167576/019fba08-2702-70a8-b5da-3c27223c8f3c.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.lake.k12.fl.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7031600837707504709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-county-schools",
      "poi_latitude": "28.8115224",
      "poi_longitude": "-81.729248",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 352-253-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-2ee9-76ad-8851-6881366b538f",
        "storage_key": "property/6767906449167576/019fba08-2ee9-76ad-8851-6881366b538f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5xfIi3O954gRRRzl9bRDlWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5c12db12-7f90-4e84-8043-e2eb4a47548d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Carver Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "239 Cardinal St, Eustis, FL 32726, USA",
      "poi_short_description": "City of Eustis neighborhood park on Cardinal Street.",
      "poi_long_description": "City of Eustis neighborhood park on Cardinal Street.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-1b43-766c-9dfa-3c5cf3e7f0d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-1b43-766c-9dfa-3c5cf3e7f0d5",
        "storage_key": "property/6767906449167576/019fba08-1b43-766c-9dfa-3c5cf3e7f0d5.webp",
        "width": 1280,
        "height": 597
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4608497218724258891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carver-park",
      "poi_latitude": "28.8566306",
      "poi_longitude": "-81.66206489999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbe3-7428-9d7e-7e2e95ef9577.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbe3-7428-9d7e-7e2e95ef9577",
        "storage_key": "property/6767906449167576/019fba05-cbe3-7428-9d7e-7e2e95ef9577.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____OxOj54gRS2Rvts2r9D8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b916328f-f818-4111-a21c-816d0d0aa7ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Hidden Waters Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600-1898 Country Club Rd, Eustis, FL 32726, USA",
      "poi_short_description": "Hiking area with a spring, creeks, and hills, including a challenging trail.",
      "poi_long_description": "Hiking area with a spring, creeks, and hills, including a challenging trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-16a2-73aa-87ee-058a566ce680.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-16a2-73aa-87ee-058a566ce680",
        "storage_key": "property/6767906449167576/019fba08-16a2-73aa-87ee-058a566ce680.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lcwa.org/land_resources/open_preserves.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=14890066107066571079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hidden-waters-preserve",
      "poi_latitude": "28.8380713",
      "poi_longitude": "-81.66056259999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 352-324-6141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2ef2-72c8-b686-10f45fc1b416.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba08-2ef2-72c8-b686-10f45fc1b416",
        "storage_key": "property/6767906449167576/019fba08-2ef2-72c8-b686-10f45fc1b416.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJhQjZlDuj54gRR1nJwTskpM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_b63924de-d759-4db2-a05b-9072adfc4ae1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Palmetto Point Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1651 Getford Rd, Eustis, FL 32726, USA",
      "poi_short_description": "Relaxed green space featuring a disc golf course, paved trails and exercise stations.",
      "poi_long_description": "Relaxed green space featuring a disc golf course, paved trails and exercise stations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-16fb-753c-8300-f51d919e2acc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-16fb-753c-8300-f51d919e2acc",
        "storage_key": "property/6767906449167576/019fba08-16fb-753c-8300-f51d919e2acc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.eustis.org/Parks/Palmetto-Point-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5585431838289835808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palmetto-point-park",
      "poi_latitude": "28.865774",
      "poi_longitude": "-81.6689012",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 352-357-8510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbe3-7428-9d7e-7e2e95ef9577.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbe3-7428-9d7e-7e2e95ef9577",
        "storage_key": "property/6767906449167576/019fba05-cbe3-7428-9d7e-7e2e95ef9577.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJX_z1HGmj54gRIDds_qlwg00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7798a0d1-4124-468c-9fdc-77a42a9d2946",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Ferran Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "250 Ferran Park Dr, Eustis, FL 32726, USA",
      "poi_short_description": "Lakeside park offering a bandshell, picnic tables, a playground, and a splash pad.",
      "poi_long_description": "Lakeside park offering a bandshell, picnic tables, a playground, and a splash pad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-fd23-7176-970c-1d88156e0081.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-fd23-7176-970c-1d88156e0081",
        "storage_key": "property/6767906449167576/019fba07-fd23-7176-970c-1d88156e0081.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.eustis.org/Parks/Ferran-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2832593476021559204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ferran-park",
      "poi_latitude": "28.8539742",
      "poi_longitude": "-81.6865",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 352-357-7969",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbe3-7428-9d7e-7e2e95ef9577.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbe3-7428-9d7e-7e2e95ef9577",
        "storage_key": "property/6767906449167576/019fba05-cbe3-7428-9d7e-7e2e95ef9577.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlb5TDjSj54gRpJ9aO8JkTyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1b8b86c0-256d-4874-8d4f-5c3e54ef335c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Trout Lake Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "520 East, County Rd 44, Eustis, FL 32736, USA",
      "poi_short_description": "Wooded nature preserve featuring trails and a museum, plus exhibits and boardwalks.",
      "poi_long_description": "Wooded nature preserve featuring trails and a museum, plus exhibits and boardwalks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-0a1b-74bd-b9de-c51a6b6800b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-0a1b-74bd-b9de-c51a6b6800b4",
        "storage_key": "property/6767906449167576/019fba08-0a1b-74bd-b9de-c51a6b6800b4.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://www.troutlakenaturecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=607737236413148219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trout-lake-nature-center",
      "poi_latitude": "28.872999",
      "poi_longitude": "-81.681783",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 352-357-7536",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbe3-7428-9d7e-7e2e95ef9577.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbe3-7428-9d7e-7e2e95ef9577",
        "storage_key": "property/6767906449167576/019fba05-cbe3-7428-9d7e-7e2e95ef9577.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIy0N4Uej54gRO-wu7csdbwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_2585cff3-3567-4d05-815e-d9bff6f57308",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Pine Meadows Recreation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17110 Pine Meadows Golf Course Rd, Eustis, FL 32726, USA",
      "poi_short_description": "Lake County recreation area on Pine Meadows Golf Course Road in Eustis.",
      "poi_long_description": "Lake County recreation area on Pine Meadows Golf Course Road in Eustis.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-1560-713d-acb6-db06813d2669.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-1560-713d-acb6-db06813d2669",
        "storage_key": "property/6767906449167576/019fba08-1560-713d-acb6-db06813d2669.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lakecountyfl.gov/parks-and-trails/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=6982899060496643114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pine-meadows-recreation-area",
      "poi_latitude": "28.8834424",
      "poi_longitude": "-81.6778693",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 352-253-4950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbe3-7428-9d7e-7e2e95ef9577.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbe3-7428-9d7e-7e2e95ef9577",
        "storage_key": "property/6767906449167576/019fba05-cbe3-7428-9d7e-7e2e95ef9577.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB111wxWl54gRKrRP07I96GA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5f71a52b-8e35-403f-b278-9e56cce6740e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "The State Theatre of Eustis Home of Bay Street Players",
      "poi_type": "Entertainment",
      "poi_address": "109 N Bay St, Eustis, FL 32726, USA",
      "poi_short_description": "Plays staged by a young, local cast and live music in a small, historic venue featuring original architecture and a concession stand.",
      "poi_long_description": "Plays staged by a young, local cast and live music in a small, historic venue featuring original architecture and a concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba07-fbb3-755b-a00a-522cd26f1cc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba07-fbb3-755b-a00a-522cd26f1cc3",
        "storage_key": "property/6767906449167576/019fba07-fbb3-755b-a00a-522cd26f1cc3.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://eustisstatetheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15907796453698208136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-state-theatre-of-eustis-home-of-bay-street-players",
      "poi_latitude": "28.8539106",
      "poi_longitude": "-81.6855638",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 352-357-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbef-738b-bd3e-b8b8df6451f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbef-738b-bd3e-b8b8df6451f5",
        "storage_key": "property/6767906449167576/019fba05-cbef-738b-bd3e-b8b8df6451f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhVuzqTaj54gRiIHmbZfYw9w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_98c30dcd-9749-489d-86f3-28f01fb2b559",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Eustis Historical Museum",
      "poi_type": "Entertainment",
      "poi_address": "536 N Bay St, Eustis, FL 32726, USA",
      "poi_short_description": "Tours of this restored 1910 home reveal details about its original owners and regional history.",
      "poi_long_description": "Tours of this restored 1910 home reveal details about its original owners and regional history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-0001-74da-b228-a5c5d79b536f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-0001-74da-b228-a5c5d79b536f",
        "storage_key": "property/6767906449167576/019fba08-0001-74da-b228-a5c5d79b536f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.eustis.org/Residents/CliffordHouse",
      "poi_directions_map_url": "https://maps.google.com/?cid=8119560766224607926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eustis-historical-museum",
      "poi_latitude": "28.8579818",
      "poi_longitude": "-81.68607999999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 352-483-5491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbe5-703f-af64-ef7a126b07b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbe5-703f-af64-ef7a126b07b3",
        "storage_key": "property/6767906449167576/019fba05-cbe5-703f-af64-ef7a126b07b3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJIzl_5zWj54gRtioEY395rnA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_cba5bab5-9151-48eb-bd52-25ca9686ed89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Eustis Community Center",
      "poi_type": "Entertainment",
      "poi_address": "601 Northshore Dr, Eustis, FL 32726, USA",
      "poi_short_description": "Lakeside, clean community center that hosts events, weddings and parties.",
      "poi_long_description": "Lakeside, clean community center that hosts events, weddings and parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-1303-72e7-abad-685a37495757.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-1303-72e7-abad-685a37495757",
        "storage_key": "property/6767906449167576/019fba08-1303-72e7-abad-685a37495757.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.eustis.org/City-Facility-Rentals/Community-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=2931959796063475968&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eustis-community-center",
      "poi_latitude": "28.8585908",
      "poi_longitude": "-81.6862728",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 352-483-5430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbef-738b-bd3e-b8b8df6451f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbef-738b-bd3e-b8b8df6451f5",
        "storage_key": "property/6767906449167576/019fba05-cbef-738b-bd3e-b8b8df6451f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVWV-jWj54gRABkXfOZpsCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_e374150e-b473-48f7-81b6-cfd878ebd392",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Mount Dora Center for the Arts",
      "poi_type": "Entertainment",
      "poi_address": "847 E 5th Ave, Mt Dora, FL 32757, USA",
      "poi_short_description": "Nonprofit arts center and gallery in downtown Mount Dora with exhibitions and classes.",
      "poi_long_description": "Nonprofit arts center and gallery in downtown Mount Dora with exhibitions and classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-006b-708d-b2c0-7e24beb9b868.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-006b-708d-b2c0-7e24beb9b868",
        "storage_key": "property/6767906449167576/019fba08-006b-708d-b2c0-7e24beb9b868.webp",
        "width": 1280,
        "height": 916
      },
      "poi_business_url": "https://mountdoraart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16402489091051873835&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mount-dora-center-for-the-arts",
      "poi_latitude": "28.8008502",
      "poi_longitude": "-81.6366652",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 352-385-7004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cbef-738b-bd3e-b8b8df6451f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cbef-738b-bd3e-b8b8df6451f5",
        "storage_key": "property/6767906449167576/019fba05-cbef-738b-bd3e-b8b8df6451f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhRhiGGOi54gRK-ZdmOxYoeM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_5e25930a-e9e5-42ba-81b5-b9d68831bc9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Orlando Sanford International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1200 Red Cleveland Blvd, Sanford, FL 32773, USA",
      "poi_short_description": "Commercial airport in Sanford (SFB), the closest airline service to Eustis.",
      "poi_long_description": "Commercial airport in Sanford (SFB), the closest airline service to Eustis.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2115-723b-97fa-bfaf921bbb5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-2115-723b-97fa-bfaf921bbb5a",
        "storage_key": "property/6767906449167576/019fba08-2115-723b-97fa-bfaf921bbb5a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://flysfb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10623798462706659909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orlando-sanford-international-airport",
      "poi_latitude": "28.7760155",
      "poi_longitude": "-81.234467",
      "poi_miles_from_property": "31.2 mi",
      "poi_walking_minutes": "11 hours 20 mins",
      "poi_biking_minutes": "3 hours 32 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "+1 407-585-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-cc01-7079-ad88-196c990ab503.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-cc01-7079-ad88-196c990ab503",
        "storage_key": "property/6767906449167576/019fba05-cc01-7079-ad88-196c990ab503.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5d7ffVJr54gRRbL4HmpQb5M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_a7d2b180-50a5-40bd-8bba-1edf7fc4cc69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "City of Eustis",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10 N Grove St #3, Eustis, FL 32726, USA",
      "poi_short_description": "Eustis City Hall and municipal offices on N Grove Street.",
      "poi_long_description": "Eustis City Hall and municipal offices on N Grove Street.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-c3a0-774e-a6be-763208a152e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba05-c3a0-774e-a6be-763208a152e3",
        "storage_key": "property/6767906449167576/019fba05-c3a0-774e-a6be-763208a152e3.webp",
        "width": 1280,
        "height": 1037
      },
      "poi_business_url": "http://www.eustis.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9018746252453259200&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-eustis",
      "poi_latitude": "28.8530792",
      "poi_longitude": "-81.6838676",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 352-483-5430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-ce77-77f1-a28d-51951b4edb1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-ce77-77f1-a28d-51951b4edb1a",
        "storage_key": "property/6767906449167576/019fba05-ce77-77f1-a28d-51951b4edb1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt2GgMzGj54gRwKfc6O4FKX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_1fde4f81-3cb2-47b8-b553-0bbe61f85b3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "poi_name": "Lake County Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "315 W Main St, Tavares, FL 32778, USA",
      "poi_short_description": "Lake County government offices in Tavares, the county seat.",
      "poi_long_description": "Lake County government offices in Tavares, the county seat.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba08-2651-765c-a1f5-4ca0b1d8c80e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fba08-2651-765c-a1f5-4ca0b1d8c80e",
        "storage_key": "property/6767906449167576/019fba08-2651-765c-a1f5-4ca0b1d8c80e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lakecountyfl.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6116763528262241256&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-county-administration-building",
      "poi_latitude": "28.8020152",
      "poi_longitude": "-81.7301412",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 352-343-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167576/019fba05-ce77-77f1-a28d-51951b4edb1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fba05-ce77-77f1-a28d-51951b4edb1a",
        "storage_key": "property/6767906449167576/019fba05-ce77-77f1-a28d-51951b4edb1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm4d4hnm954gR6MsiXQUc41Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_c1a6e81d7d2d9fabf0ef984b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4658faa2f9dc932441324978",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7c3db534243032b53f7c81b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2d3f5ca62b14111665860282",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_028a0e79374cdaed052cbb12",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_174d7654f8e062374a2bb9f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [
    {
      "id": "custom_bfcba730-6383-4fb5-8170-e53f17a28277",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Laurel Oak home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Laurel Oak",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=6iqJHNSE33Z"
    },
    {
      "id": "custom_54aab782-82ea-4d74-9c60-db7d95200839",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Willow Oak home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Willow Oak",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=RVmsV6d76Uw"
    },
    {
      "id": "custom_1a42043f-9f38-4616-933c-d67c6a9663f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Chapman Oak home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Chapman Oak",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=SxGC8apvqoS"
    },
    {
      "id": "custom_ef115f7b-bacf-4df4-92b0-a5ba79cf8791",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the White Oak home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "White Oak",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=MD4Pf1Tv4M4"
    },
    {
      "id": "custom_9ef72e3b-9c45-495b-a969-c13ba5c6bc26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Scarlet Oak home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Scarlet Oak",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ML53xSgizPu"
    },
    {
      "id": "custom_03c96e9a-8cd9-409d-9b60-311040181f4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Banyan Oak home",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Banyan Oak",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=cuUrHMEqL6S"
    }
  ],
  "faqs": [
    {
      "id": "custom_2d3e43c9-7562-4ce6-b28d-15042f351e5f",
      "question": "Application Fee",
      "answer": "$100 per person for all occupants over 18.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_43cd615b-4b1f-4287-ab60-e0c7d8194c60",
      "question": "Administration Fee & Additional Charges",
      "answer": "A one-time administration fee of $350 is required at move-in. Please review the information below regarding additional charges and fees that may arise throughout your lease term.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_739b730e-8d57-4f76-a0ea-1503bf1c8f68",
      "question": "Utility Billing Fee",
      "answer": "$11.99/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_ece15b81-3e2e-402d-b451-e206e39d16da",
      "question": "Pet Fees",
      "answer": "Non-refundable pet fee of $300 for one pet ($500 for two pets). Pet rent $35/month per pet",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_b835797d-4600-4659-ad47-477447267ffb",
      "question": "Concierge Package",
      "answer": "$10.95/month Bi-annual filter change Exterior pest control 24 hour maintenance response on emergencies Positive credit reporting",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_a6f27141-1351-40c9-893a-a5bff7c99eae",
      "question": "Smart Home",
      "answer": "Smart Home Fee - $35/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_9b1580f5-d882-46e3-be20-768fae12f6be",
      "question": "Solar",
      "answer": "Solar Panel Fee - $50/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_4924887a-b2ff-4ad3-973e-9ed904e698a6",
      "question": "Landscape Services",
      "answer": "Townhomes: $45/month Single-family homes: $70/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_360eeea7-b7ba-4f8b-8b91-114fa7423ad3",
      "question": "Occupancy Guidelines",
      "answer": "The maximum occupancy for Quinn properties is two (2) persons per bedroom, plus one (1) additional occupant per home. Occupancy standards may vary by region based on local city, county, and state laws.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_03ab1fdb-fef3-45f1-80e2-8e5b0beaf9cd",
      "question": "Application",
      "answer": "All adults, 18 years of age, or considered an adult under state law, are required to complete an application in its entirety. All occupants applying for the property must reside in the property. By acknowledging the terms and conditions outlined in the Quinn rental criteria, the Applicant confirms all information provided is true and accurate. Any falsification, fabrication, or untruthful answers and supporting documentation shall result in an automatic denial. Applicants are required, unless otherwise noted, to pay a $100.00 non-refundable application fee to authorize a background check and additional qualification processes; Properties may not be held off the market for greater than ten (10) days, unless a Quinn representative approves an extension. All applicants are required, unless otherwise specified, to pay a non-refundable $350 administration fee to secure a specific home and remove it from the market. All administration fees are non-refundable unless the application is declined. Upon Applicant approval, Leases are required to be signed within 24 hours of generation. In the event Lease is not signed within the 24-hour time Quinn may elect to cancel the application and place the home back on the market. All Applicants are required to provide valid identification. Non-US citizens applying to a home may be required to present information acknowledging the individual's right to live in the United States through the duration of the lease term. Approved applications are valid for thirty (30) days, after that time period, all Applicants must provide written consent for additional screening, credit checks, income verification, and re-qualification for a property managed by Quinn PM LLC. Any application that provides falsified or incorrect information may be subject to automatic disqualification. If an Applicant falsifies their application or supporting documentation, Quinn has the right to hold all deposits and fees paid to apply towards liquidated damages. DISCLAIMER: Rentgrow reports information about applicants in accordance with the applicable state and federal law. However, other federal, state or local laws and regulations may apply. This application, even if accepted, shall under no circumstances be considered a lease agreement between Applicant and Quinn, nor an offer to lease, and does not create a landlord/tenant relationship. No lease shall exist between an Applicant and Quinn unless and until the parties enter a fully executed Lease Agreement conditioned on the Applicant paying all required fees, security deposits, and rent. At Quinn PM LLC's sole discretion, Quinn PM LLC reserves the right to cancel an approved application, and refuse occupancy to any applicant(s) who disrupts or interferes with Landlord's business operations, or communicates with Landlord, Landlord's agents, or their employees in an unreasonable, discourteous, rude, or hostile manner.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_4f62bd0a-c429-494c-b8ac-c175b0276172",
      "question": "Guarantors",
      "answer": "Guarantors may be accepted to support an application and must complete all required application and screening processes. Applicants who do not independently meet qualification criteria may also have the option to utilize a third-party lease guarantee program through TheGuarantors, which does not add an additional occupant or leaseholder.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_ea1ac958-aaac-4c0b-a322-eae580ce08f9",
      "question": "Income",
      "answer": "Income Requirements: Household income requirements are based upon the market and other qualification factors within the application process. In-State Income Verification: Proof of income being made in the state where you are wishing to rent a home is required. Examples include, but are not limited to, state taxes shown on your pay statements, an offer letter or transfer letter confirming you are beginning a new role in that state, or proof that you are a remote employee. Job Transfer/New Role: Applicants with an offer of employment or transfer of role from their existing employer are required to provide an Offer Letter or Transfer Letter on employer letterhead confirming terms of compensation and start date. The letter should be signed and dated by the offeror. Contract-Based Employment: At select communities, an additional income verification option may be available for applicants working on a contract basis. This may include providing a notarized letter on company letterhead confirming income from Human Resources, Payroll, the business owner, or a company officer. Additional documentation may be required to verify the stated income. Additional Income Sources: Social Security Benefits, Child Support, Alimony, Disability, Retirement, Pensions, VA Benefits and complete Bank Statements are accepted. Items containing redacted or otherwise altered information are subject to additional verification and/or denial. Additional Documentation: Quinn may request additional proof of income if the documents provided are insufficient. False or Altered Documentation: Applicants who provide any false, counterfeit, or other fake documentation are subject to denial, even if discovered after approval. Any falsified documents will result in a denial.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_7cba8316-c8b0-43e8-85d5-b768bef6e670",
      "question": "Security Deposit",
      "answer": "An applicant's security deposit is determined by the score of the applicant and may result in an increased security deposit for approval.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_f4628885-232b-43ca-8924-b476efacb84c",
      "question": "Credit Report",
      "answer": "All applicant's credit history enters a scoring model to determine qualifications for each application. The SafeRent Score is determined from an analysis of information found in each applicant's consumer credit report, application, and previous rental histories (if applicable). Consumer reports may include but are not limited to payment history, bankruptcies, number and type of accounts, collection activity, outstanding debt and credit inquiries. In addition, the scoring process includes income-to-rent ratio, eviction records, and subprime credit records. Current Open Bankruptcies (Chapter 7 or 13) will result in an automatic denial. Applicants are subject to further verification at the request of a Quinn representative. For applications in the state of South Carolina: Applicant(s) does hereby consent upon completion and meeting the criteria of a credit and rental history screening, a criminal background report will be processed by Quintasen Holdings, LLC to complete screening of the consumer information report.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_955b12a2-dc84-496c-a606-3c62f84b386f",
      "question": "Rental History",
      "answer": "Prior Evictions, filed or enforced, may result in an automatic denial of the application. Any outstanding debt or judgment owed to any prior landlord may result in a denial. Quinn may request rental verification if rental history cannot be verified.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_b1c1906d-fd12-401c-9d99-ec974784485d",
      "question": "Criminal History",
      "answer": "Each Applicant is subject to a criminal background check. Criminal background screening is broken into the following categories 1) Crimes Against Persons, 2) Property, and 3) Society. Criminal histories presented through applicant screening reports pertaining to weapons, drugs, violence, or any other act that poses a threat to household, neighborhood, vendors, Quinn employees, or the physical property itself, may result in a denial. Criminal history will be assessed on the risk to persons or property by an applicant including but not limited to the type of crime; the severity of the crime; circumstance of the crime; and the length of time since the crime occurred. Denied Applicants may dispute any wrongful record claims by contacting Screening Works and following the process as outlined in their action letter and Screening Works. Criminal background screening is also governed by federal, state or local laws which regulate Quinn's screening processes. An Office of Foreign Assets Control (OFAC) search is completed for each Applicant. If Applicant appears on the OFAC list, the application will be denied.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_4c8ba0c5-1dca-4fc7-8dae-e8a3fb38162f",
      "question": "Pets",
      "answer": "Pet Screening: Mandatory for all applicants before move-in. Pet Restrictions: Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained from Quinn Property Management. Fees: Non-refundable pet fee of $300 for one pet; $500 for up to two pets. Monthly pet rent of $35 per pet. Prohibited Animals: Dangerous or poisonous animals and exotic pets are not permitted. Fish Tanks: Limited to 20 gallons. No pet fee or pet rent required for fish. Assistive Animals: Animals assisting persons with disabilities are exempt from these restrictions and are not considered pets. Vaccinations and Registrations: All pets must have up-to-date vaccinations and current state, city, and county registrations. Visiting Animals: No visiting animals allowed under any circumstances.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_7959cb38-3f49-4e9c-8bcb-54028f946b34",
      "question": "Assistance Animals",
      "answer": "No Cost - Pet screening is mandatory as part of the application process prior to move in with a 2-5 business day approval turnaround time. Assistive Animals for persons with disabilities are not considered to be pets and are not subject to the pet restrictions bestowed in this section.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_3781dc46-48c9-4b66-b83e-4f4c9cf9f60b",
      "question": "Vehicles",
      "answer": "No more than four (4) vehicles are permitted on the Premises. Vehicles must be operational and have current and valid registration based upon state law. Additional HOA restrictions may apply to the number of vehicles, commercial vehicles and allowed parking locations. If your home is contained in an HOA review the HOA's restrictive covenants for more information regarding vehicle guidelines.",
      "category": "Vehicles",
      "source": "custom"
    },
    {
      "id": "custom_e58c0b7e-feba-493e-be8b-ab570d13578d",
      "question": "Renters Insurance",
      "answer": "To alleviate concerns and help you protect what matters most we have partnered with Assurant, a preferred insurance provider, to make the process of protecting your home and property seamless. We know how busy life can be, and we wanted to provide you an option that makes the selection of an insurance policy simple, while meeting your lease requirements. Please visit this page for more information on renters insurance requirements.",
      "category": "Renters Insurance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_df0ece484ec6541cf7364396",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "yardi",
      "external_id": "2397853",
      "pet_type": "all",
      "allowed": true,
      "max_count": 3,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    },
    {
      "id": "ec_dcc672fa12bb886ef9c5d2de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "yardi",
      "external_id": "2495161",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    },
    {
      "id": "ec_cbd925dcc23f76f5c29532be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "yardi",
      "external_id": "2495160",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-95c7-73e7-89e4-93803c668b8a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Eleven Oaks Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576"
    },
    {
      "lead_collector_id": "01a0abe0-964b-77a9-b6f8-d80944d3091b",
      "lead_source": "LANDING_PAGE",
      "name": "Eleven Oaks Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-eustis-fl",
      "search_query": "apartments with in-unit laundry in Eustis FL",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Eustis, FL",
      "h2_subtitle": "Experience convenience with in-unit laundry in our Eustis, FL apartments. Enjoy the ease of laundry days at Eleven Oaks.",
      "page_copy": "Discover the modern living experience at Eleven Oaks, where our apartments with in-unit laundry in Eustis, FL redefine convenience. Situated in the charming surroundings of Lake County, our community ensures your daily routines are seamless and stress-free. Our residents love the blend of functionality and style offered by stainless steel appliances, which complement our in-unit laundry facilities perfectly.\n\nAt Eleven Oaks, not only do you enjoy laundry convenience right at home, but you also gain access to community amenities like a dog park, a private park, and a delightful fire pit area. Perfect for families, our playground provides endless fun for the little ones. Choose Eleven Oaks, and relish a balanced lifestyle in Eustis, FL, with all the conveniences and comforts you need.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry, Eustis, FL",
      "seo_description": "Discover convenience at Eleven Oaks in Eustis, FL, where apartments feature in-unit laundry and amazing amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "generator",
      "page_item_url": "dog-park-apartments-lake-county",
      "search_query": "dog park apartments Lake County",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Lake County",
      "h2_subtitle": "Find pet-friendly apartments with a dog park in Lake County. Eleven Oaks offers ideal spaces for you and your pets.",
      "page_copy": "Welcome to Eleven Oaks, your go-to destination for dog park apartments in Lake County. Designed with pet lovers in mind, our community features an expansive dog park where your furry friends can roam freely and socialize with fellow pets. Nestled in the heart of Eustis, FL, Eleven Oaks provides a harmonious blend of pet-friendly living and modern conveniences.\n\nBeyond the canine amenities, our complex offers a fire pit area, a peaceful private park, and a fun-filled playground, perfect for residents of all ages. Inside our apartments, enjoy the sleek look of stainless steel appliances, blending style with functionality. Join our community at Eleven Oaks, where we prioritize both comfort and pet-friendly living in beautiful Lake County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Lake County",
      "seo_description": "Eleven Oaks offers dog park apartments in Lake County. Enjoy pet-friendly living with great amenities in Eustis, FL.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "generator",
      "page_item_url": "luxury-apartments-granite-countertops-32726",
      "search_query": "luxury apartments with granite countertops in 32726",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Granite Countertops 32726",
      "h2_subtitle": "Explore top-tier living in our Eustis apartments. Enjoy luxury with granite countertops in the vibrant 32726 area.",
      "page_copy": "Step into the world of luxury at Eleven Oaks, where our apartments with granite countertops in the 32726 area cater to those who appreciate fine living. Located in Eustis, FL, Eleven Oaks offers a blend of elegance and practicality, perfect for those seeking upscale accommodations. The sophisticated design of our kitchen spaces includes granite countertops, adding a touch of class and durability to your daily culinary activities.\n\nIn addition to our chic interiors, residents enjoy an array of amenities designed for relaxation and entertainment. Unwind at our private park, or gather around the fire pit area with friends. Our community also welcomes your furry companions with a well-maintained dog park. Choose Eleven Oaks in Eustis, and experience luxurious living in a lively community setting.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Granite Countertops in 32726",
      "seo_description": "Discover luxury living at Eleven Oaks in the 32726 area, featuring apartments with exquisite granite countertops and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "generator",
      "page_item_url": "smart-home-technology-apartments-eustis",
      "search_query": "smart-home technology apartments Eustis",
      "category": "Amenity",
      "h1_title": "Smart-Home Technology Apartments in Eustis",
      "h2_subtitle": "Experience advanced living with smart-home technology in our Eustis apartments. Elevate your lifestyle at Eleven Oaks.",
      "page_copy": "At Eleven Oaks, step into the future with our cutting-edge smart-home technology apartments in Eustis. Designed for the modern resident, these apartments come equipped with the latest in automated home systems to make life easier and more efficient. Located amid the scenic beauty of Lake County, our community offers a unique blend of advanced technology and comfortable living.\n\nBeyond innovative technology, Eleven Oaks residents enjoy a vibrant community atmosphere. With amenities such as a dog park, a private park, and a fire pit area, our complex provides spaces to relax and socialize. Inside, stainless steel appliances complement the sleek design of your smart home. Choose Eleven Oaks in Eustis for a seamless integration of technology and lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart-Home Technology Apartments Eustis",
      "seo_description": "Live in the future with smart-home technology at Eleven Oaks in Eustis. Modern living with great amenities awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "generator",
      "page_item_url": "apartments-stainless-steel-appliances-lake-county",
      "search_query": "apartments with stainless steel appliances Lake County",
      "category": "Amenity",
      "h1_title": "Apartments with Stainless Steel Appliances Lake County",
      "h2_subtitle": "Discover modern living in Lake County with our stylish apartments. Experience luxury with stainless steel appliances at Eleven Oaks.",
      "page_copy": "Welcome to Eleven Oaks, the ideal choice for those seeking apartments with stainless steel appliances in Lake County. Situated in serene Eustis, FL, our apartments cater to residents who value a blend of style and function. Our stainless steel appliances offer a contemporary look that enhances your kitchen's aesthetic while providing reliable performance.\n\nBeyond stylish interiors, Eleven Oaks offers residents an array of amenities such as a dog park, a private park, and a cozy fire pit area. These features create an inviting community atmosphere perfect for relaxation and socializing. Explore the exceptional living experience at Eleven Oaks, where modern conveniences meet tranquil living in the heart of Lake County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Stainless Steel Appliances Lake County",
      "seo_description": "Discover Eleven Oaks in Lake County—stylish apartments featuring stainless steel appliances and unbeatable amenities in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-eustis-fl",
      "search_query": "three bedroom apartments eustis fl",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Eustis, FL",
      "h2_subtitle": "Find spacious three-bedroom apartments in Eustis, FL. Eleven Oaks offers roomy layouts and premium amenities.",
      "page_copy": "Discover the perfect blend of comfort and space with our three-bedroom apartments in Eustis, FL, at Eleven Oaks. Designed for families or individuals seeking additional room, these apartments provide ample living space matched with modern conveniences. Located in the heart of Eustis, our community offers easy access to local attractions and daily necessities.\n\nEleven Oaks boasts an array of amenities that enhance your living experience. Enjoy leisurely walks in our private park, entertain friends at the fire pit area, or take the kids to the playground. With the added feature of stainless steel appliances in every apartment, living in Eustis at Eleven Oaks seamlessly combines comfort and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Eustis, FL",
      "seo_description": "Explore spacious living at Eleven Oaks in Eustis, FL. Our three-bedroom apartments offer comfort and top amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "generator",
      "page_item_url": "two-bedroom-rentals-lake-county",
      "search_query": "two bedroom rentals lake county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Rentals in Lake County",
      "h2_subtitle": "Explore ideal two-bedroom rentals in scenic Lake County. Enjoy spacious living at Eleven Oaks.",
      "page_copy": "Welcome to Eleven Oaks, where you'll find superb two-bedroom rentals nestled in the heart of Lake County. Our community provides residents with a perfect mix of comfortable living spaces and exceptional amenities. Each two-bedroom apartment embodies modern design and functionality, making it a perfect fit for roommates, small families, or anyone needing extra space.\n\nBeyond the comforts of home, residents can enjoy a vibrant community setting. Features like a playful dog park, a serene private park, and an inviting fire pit area cater to lifestyle and leisure needs. With sleek stainless steel appliances in every unit, these two-bedroom rentals offer a premium living experience in beautiful Lake County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Rentals Lake County",
      "seo_description": "Discover spacious two-bedroom rentals at Eleven Oaks in Lake County, featuring modern amenities and a welcoming community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "generator",
      "page_item_url": "apartments-near-adventhealth-waterman-eustis",
      "search_query": "apartments near AdventHealth Waterman Eustis",
      "category": "Hospital",
      "h1_title": "Apartments Near AdventHealth Waterman Eustis",
      "h2_subtitle": "Live close to AdventHealth Waterman in Eustis. Discover the convenience of Eleven Oaks' prime location.",
      "page_copy": "For those seeking apartments near AdventHealth Waterman Eustis, Eleven Oaks offers the perfect balance of proximity and comfort. Located just a short drive from the hospital, our community caters to medical professionals and families alike, providing an ideal living space with easy access to work and healthcare.\n\nAt Eleven Oaks, residents enjoy not only a convenient location but also a suite of amenities that enhance daily living. The community features a dog park and a private park for relaxation and recreation. Inside our apartments, stainless steel appliances set the tone for modern comfort. Experience the best of Eustis living at Eleven Oaks—where convenience meets a welcoming community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near AdventHealth Waterman Eustis",
      "seo_description": "Find convenience at Eleven Oaks, offering apartments near AdventHealth Waterman in Eustis with modern amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "generator",
      "page_item_url": "eleven-oaks-apartments-near-pam-health-tavares",
      "search_query": "Eleven Oaks apartments close to PAM Health Rehabilitation Hospital Tavares FL",
      "category": "Hospital",
      "h1_title": "Eleven Oaks Near PAM Health Rehabilitation",
      "h2_subtitle": "Discover comfortable living at Eleven Oaks, conveniently located near PAM Health Rehabilitation Hospital in Tavares, FL.",
      "page_copy": "Experience the convenience and comfort of living at Eleven Oaks, where our apartments are strategically located close to PAM Health Rehabilitation Hospital in Tavares, FL. This makes our community an ideal choice for healthcare professionals and families who value being near essential medical services.\n\nEleven Oaks is more than just a place to live; it's a community that offers a variety of amenities aimed at enhancing the quality of life. Residents can enjoy leisure time at our private park, entertain guests at the fire pit area, or let children explore the playground. Each apartment comes with stainless steel appliances, providing both style and efficiency. Join us at Eleven Oaks for a location that balances work and relaxation perfectly.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Eleven Oaks Near PAM Health Hospital Tavares",
      "seo_description": "Live comfortably at Eleven Oaks, featuring apartments near PAM Health Rehabilitation Hospital Tavares, FL, with modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "generator",
      "page_item_url": "apartments-near-gilbert-park-eustis",
      "search_query": "apartments near Gilbert Park Eustis",
      "category": "Park",
      "h1_title": "Apartments Near Gilbert Park Eustis",
      "h2_subtitle": "Discover a vibrant community at Eleven Oaks, conveniently close to Gilbert Park in Eustis.",
      "page_copy": "Located just minutes from the picturesque Gilbert Park in Eustis, Eleven Oaks offers modern apartments that perfectly blend convenience with quality living. The proximity to Gilbert Park provides residents with easy access to green spaces and recreational opportunities, making it a desirable place to call home.\n\nEleven Oaks stands out with its exceptional amenities, including a communal fire pit area and a playful playground for families. Our dog park is perfect for pet owners, while the private park offers serene moments without leaving the community. Each apartment is fitted with stainless steel appliances, ensuring a sleek, modern living experience. Explore life at Eleven Oaks, where excitement and relaxation meet near the charming Gilbert Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Gilbert Park Eustis",
      "seo_description": "Find modern living at Eleven Oaks, offering apartments near Gilbert Park in Eustis, with a community full of amenities and beautiful surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "generator",
      "page_item_url": "apartments-close-to-wooton-park-fl",
      "search_query": "apartments close to Wooton Park FL",
      "category": "Park",
      "h1_title": "Apartments Close to Wooton Park, FL",
      "h2_subtitle": "Experience Lakeside Living Near Wooton Park. Choose Eleven Oaks for spacious living a stone's throw from Wooton Park in Florida.",
      "page_copy": "Nestled near the scenic Wooton Park, Eleven Oaks in Eustis, FL, is the preferred choice for those seeking apartments close to nature without sacrificing the comforts of modern living. The serene setting near Wooton Park is perfect for residents who enjoy outdoor activities and picturesque lake views.\n\nEleven Oaks offers an impressive range of amenities designed for relaxation and enjoyment. Our private park and playground provide spaces for families to unwind and play, while the dog park caters to our furry friends. Inside the apartment homes, stainless steel appliances are standard, ensuring both functionality and modern style. At Eleven Oaks, you enjoy the perfect blend of nature and contemporary living, just around the corner from Wooton Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Wooton Park, FL",
      "seo_description": "Discover Eleven Oaks: Spacious apartments with great amenities near beautiful Wooton Park in Florida, offering a perfect blend of nature and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "generator",
      "page_item_url": "apartment-homes-by-trimble-park-32726",
      "search_query": "apartment homes by Trimble Park 32726",
      "category": "Park",
      "h1_title": "Apartment Homes by Trimble Park 32726",
      "h2_subtitle": "Explore Eleven Oaks, beautiful apartment homes located near Trimble Park in the heart of Eustis, FL 32726.",
      "page_copy": "Situated within the inviting area of 32726, Eleven Oaks offers stunning apartment homes just a short distance from Trimble Park. This location is ideal for nature lovers who want quick access to the park’s scenic trails and tranquil lake views, providing a gorgeous backdrop for everyday living.\n\nAt Eleven Oaks, our residents enjoy a lifestyle enriched by excellent amenities. The community features a cozy fire pit area and a well-maintained dog park, promising leisure and fun for all. Within each apartment home, you'll find stainless steel appliances that enhance both form and functionality. With these thoughtful details, Eleven Oaks represents more than just a residence near Trimble Park—it's a place you’ll love to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes by Trimble Park 32726",
      "seo_description": "Find your ideal living at Eleven Oaks, offering beautiful apartment homes near Trimble Park in Eustis, FL 32726, with top-notch amenities and serene settings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167576",
      "source": "generator",
      "page_item_url": "living-near-donnelly-park-lake-county",
      "search_query": "living near Donnelly Park Lake County",
      "category": "Park",
      "h1_title": "Living Near Donnelly Park, Lake County",
      "h2_subtitle": "Enjoy the charming lifestyle of Eleven Oaks, with exceptional living options near Donnelly Park in Lake County.",
      "page_copy": "Eleven Oaks offers an unparalleled living experience near the beautiful Donnelly Park, conveniently situated in Lake County. This prime location means you're never far from the park's lush greenery and engaging community events, making life here both vibrant and serene.\n\nOur community boasts a variety of amenities designed to enhance your lifestyle. Residents enjoy access to a private park, a relaxing fire pit area, and a dedicated playground. Stainless steel appliances in every apartment ensure a modern living environment. For pet lovers, our dog park is an additional perk, making Eleven Oaks not just a place to live, but a true community close to the natural beauty of Donnelly Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Donnelly Park, Lake County",
      "seo_description": "Discover Eleven Oaks living near Donnelly Park in Lake County. Modern amenities and a great community await you at this prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977260422"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-53ZMZZV5"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://elevenoakshomes.fatwin.com/api/websites/resources/1?x=SzUwQkx4dWtrLzdrZTBtcVNQZjQ4NHhDTXVtSmxIcGh2N1hEcnFVcWFoaFhMd3NnbVU0ZmpFOWZKYWZyODRaMTJiWFhDWHhJWkhXVnRhOUxIS0ltOGc9PQ2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57142105398"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8ywkdd1gplx"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/49c2bd06-9280-47ad-ad9d-c789b40ae211/units"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "f575c8f6-ff93-11ef-9455-83a7dba62d1b"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-942-3914"
    },
    {
      "ID": "custom_paid_social_tracking_phone_number",
      "type": "STRING",
      "value": "855-528-8442"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977260422",
  "custom_google_gtm_id": "GTM-53ZMZZV5",
  "custom_rollout_phase": "Phase 2",
  "custom_perq_script_url": "https://elevenoakshomes.fatwin.com/api/websites/resources/1?x=SzUwQkx4dWtrLzdrZTBtcVNQZjQ4NHhDTXVtSmxIcGh2N1hEcnFVcWFoaFhMd3NnbVU0ZmpFOWZKYWZyODRaMTJiWFhDWHhJWkhXVnRhOUxIS0ltOGc9PQ2",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57142105398",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/8ywkdd1gplx",
  "custom_self_guided_tour_url": "https://selftournow.com/property/49c2bd06-9280-47ad-ad9d-c789b40ae211/units",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "f575c8f6-ff93-11ef-9455-83a7dba62d1b",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_ppc_tracking_phone_number": "844-942-3914",
  "custom_paid_social_tracking_phone_number": "855-528-8442",
  "custom_audioeye_site_id": "012462c6-1256-49ee-aa19-7347e091702c",
  "custom_audioeye_site_hash": "3e838026680471b551525ee701f93a0a"
};

export const generatedAt = '2026-10-29T18:35:32.411Z';
